function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileimage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 270.6,
    y: 110.5,
    width: 338.21,
    height: 226.52,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270.6,
    y: 110.5,
    width: 338.21,
    height: 22.63,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.25,121.81a2.74,2.74,0,1,1-2.74-2.54A2.65,2.65,0,0,1,285.25,121.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.07,121.81a2.74,2.74,0,1,1-2.74-2.54A2.65,2.65,0,0,1,294.07,121.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.89,121.81a2.74,2.74,0,1,1-2.73-2.54A2.65,2.65,0,0,1,302.89,121.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.39,125a10.42,10.42,0,0,0,6.21-9.65c0-5.76-4.33-10.45-9.73-10.47s-9.8,4.62-9.82,10.38a10.41,10.41,0,0,0,6.23,9.74c-15,2.26-14.37,18.62-14.37,18.62l35.59.16S660.31,127.27,645.39,125Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.16,
    y: 85.45,
    width: 174.63,
    height: 70.63,
    rx: 6.01,
    transform: "translate(324.95 241.53) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 118.71,
    cy: 120.77,
    r: 27.68,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.72,112.28a9.59,9.59,0,0,1-5.07-2.3,6.71,6.71,0,0,1-11.84,1.32,25.42,25.42,0,0,1-1.94,7.15,10.89,10.89,0,0,1-3.51,4.29c0,2.55,0,6.6-.06,6.72a3,3,0,0,1-1,.21l.46,5.61a3.22,3.22,0,0,1-.81-.5L108,146.3a27.62,27.62,0,0,0,17.12,1.39c.13-1.85.26-4.55.34-6.3h0c-7,.2-8.89-5-8.89-5a16.34,16.34,0,0,0,9,3.16v.1c.14,0,7.08-.73,7.6-7.67.37-5.06.36-14.89.33-20A2.68,2.68,0,0,1,131.72,112.28ZM122,120.85a1,1,0,0,1-1.43.25,1,1,0,1,1,1.43-.25Zm.38-1.37c-.11.11-.77-.46-1.74-.53s-1.69.39-1.79.26.07-.27.39-.48a2.43,2.43,0,0,1,1.45-.36,2.32,2.32,0,0,1,1.38.57C122.31,119.2,122.4,119.42,122.34,119.48ZM124,131.1c-2-.9-1.44-2.54-1.44-2.54-1-.66,2.68,1.65,4.66,1.67A2.67,2.67,0,0,1,124,131.1Zm4.26-3.66a.67.67,0,0,1-.46.37,1.77,1.77,0,0,1-.44,0,4.79,4.79,0,0,1-1.59-.15,4.63,4.63,0,0,1,1.58-.24c.26,0,.46,0,.49-.19a1.42,1.42,0,0,0-.14-.73l-.64-2a26.22,26.22,0,0,1-1.34-5.27,27.42,27.42,0,0,1,1.86,5.1c.21.7.41,1.37.6,2A1.62,1.62,0,0,1,128.22,127.44Zm4.32-6.65a1,1,0,0,1-1.43-1.47,1,1,0,1,1,1.43,1.47Zm.36-1.52c-.12.12-.78-.46-1.74-.52s-1.7.39-1.8.26.07-.27.39-.48a2.3,2.3,0,0,1,1.45-.36,2.38,2.38,0,0,1,1.38.56C132.86,119,133,119.22,132.9,119.27Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.11,119.32a1,1,0,1,0,1.45,0A1,1,0,0,0,131.11,119.32Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.75,118.53c-.32.21-.44.42-.39.48s.83-.34,1.8-.26,1.62.64,1.74.52,0-.28-.32-.54a2.38,2.38,0,0,0-1.38-.56A2.3,2.3,0,0,0,129.75,118.53Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.29,119.68a1,1,0,0,0,.24,1.42,1,1,0,0,0,1.43-.25,1,1,0,0,0-.25-1.42A1,1,0,0,0,120.29,119.68Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.65,118.37a2.43,2.43,0,0,0-1.45.36c-.32.21-.44.43-.39.48s.83-.34,1.79-.26,1.63.64,1.74.53,0-.28-.31-.54A2.32,2.32,0,0,0,120.65,118.37Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.54,124.35a27.42,27.42,0,0,0-1.86-5.1,26.22,26.22,0,0,0,1.34,5.27l.64,2a1.42,1.42,0,0,1,.14.73c0,.14-.23.18-.49.19a4.63,4.63,0,0,0-1.58.24,4.79,4.79,0,0,0,1.59.15,1.77,1.77,0,0,0,.44,0,.67.67,0,0,0,.46-.37,1.62,1.62,0,0,0-.08-1.06C128,125.72,127.75,125.05,127.54,124.35Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.52,128.56s-.61,1.64,1.44,2.54a2.67,2.67,0,0,0,3.22-.87C125.2,130.21,121.55,127.9,122.52,128.56Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.58,136.42s1.85,5.18,8.89,5h0l.09-1.71v-.1A16.34,16.34,0,0,1,116.58,136.42Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.64,104.51c-.39,0-.95-2.37-3.7-3a5.52,5.52,0,0,0-4.6,1.24c-1.22-.3-3.54-2-6.69-1.3-2.21.48-4.47,2.5-5.94,4.22a14.39,14.39,0,0,1-1.79,2.1A21.83,21.83,0,0,1,106,109a7.08,7.08,0,0,0-3,5.69,12.45,12.45,0,0,0,1.73,6.35l.3.56a4.19,4.19,0,0,1,4.29-.83s0,.85,0,2a10.89,10.89,0,0,0,3.51-4.29,25.42,25.42,0,0,0,1.94-7.15A6.71,6.71,0,0,0,126.65,110a9.59,9.59,0,0,0,5.07,2.3,2.68,2.68,0,0,0,1.77-.25l.15-.08c.64-.51.42-1.47.62-2.27C134.79,107.53,134.54,104.79,130.64,104.51Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.25,129.67c-1.24.09-3.25-.11-4.13-1.81-.06.14-.12.29-.17.44a2.7,2.7,0,0,0,.32,2.43,1.53,1.53,0,0,0,2.23.21,4,4,0,0,0,1.4,3.84,3.22,3.22,0,0,0,.81.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.25,129.67a3,3,0,0,0,1-.21c0-.12,0-4.17.06-6.72,0-1.17,0-2,0-2a4.19,4.19,0,0,0-4.29.83,5.68,5.68,0,0,0-1.36,3.41,4.91,4.91,0,0,0,.4,2.9C105,129.56,107,129.76,108.25,129.67Zm-2.4-6.55a1.49,1.49,0,0,1,1.19-.8.79.79,0,0,1,.56.22.7.7,0,0,1,.19.4c0,.25-.11.35-.12.34s0-.13,0-.31a.53.53,0,0,0-.58-.35,1.21,1.21,0,0,0-.87.7,3.54,3.54,0,0,0-.46,1.45,2.59,2.59,0,0,0,.92,2.44,1.05,1.05,0,0,0,.78.07c.18-.06.27-.14.3-.12s0,.15-.23.27a1.11,1.11,0,0,1-1,0,2.71,2.71,0,0,1-1.22-2.74A3.63,3.63,0,0,1,105.85,123.12Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.52,127.48a1.11,1.11,0,0,0,1,0c.2-.12.24-.25.23-.27s-.12.06-.3.12a1.05,1.05,0,0,1-.78-.07,2.59,2.59,0,0,1-.92-2.44,3.54,3.54,0,0,1,.46-1.45,1.21,1.21,0,0,1,.87-.7.53.53,0,0,1,.58.35c.06.18,0,.29,0,.31s.14-.09.12-.34a.7.7,0,0,0-.19-.4.79.79,0,0,0-.56-.22,1.49,1.49,0,0,0-1.19.8,3.63,3.63,0,0,0-.55,1.62A2.71,2.71,0,0,0,106.52,127.48Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157.93,
    y: 110.26,
    width: 74.3,
    height: 4.85,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157.93,
    y: 122.87,
    width: 74.3,
    height: 4.85,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.91,197.24c-2.19-2.61-6.15-2.51-8.68-.42a10.62,10.62,0,0,0-4,8,10.82,10.82,0,0,0-5.19-7.41c-2.81-1.75-6.78-1.33-8.62,1.55a8.3,8.3,0,0,0-.89,6,11.46,11.46,0,0,0,2.5,5.61c4.85,5.17,7.37,6,13.4,9.49,5.48-4.26,7.25-5.36,11.36-11.12a11.49,11.49,0,0,0,1.72-5.88A8.37,8.37,0,0,0,111.91,197.24Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M685.46,428.84c0,.15-137.58.26-307.27.26S70.9,429,70.9,428.84s137.55-.26,307.29-.26S685.46,428.7,685.46,428.84Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M547.23,128H206.8a10.61,10.61,0,0,0-10.62,10.62V379.08a10.62,10.62,0,0,0,10.62,10.63H337.46s8.31,25.7-17.46,39H442.17s-29.08-10-21.61-39H547.23a10.63,10.63,0,0,0,10.63-10.62V138.63A10.62,10.62,0,0,0,547.23,128Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.56,364.42c4.63,6.62-2.62,13.87-9.24,9.24a2.33,2.33,0,0,1-.56-.57c-4.62-6.62,2.62-13.86,9.23-9.24A2.37,2.37,0,0,1,381.56,364.42Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.86,
    y: 142.42,
    width: 345.61,
    height: 205,
    rx: 3.27,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.56,
    y: 157.54,
    width: 345.61,
    height: 189.98,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.2,150.34a2.76,2.76,0,1,1-2.76-2.76A2.76,2.76,0,0,1,232.2,150.34Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.47,150.34a2.76,2.76,0,1,1-2.76-2.76A2.76,2.76,0,0,1,215.47,150.34Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.5,150.34a2.76,2.76,0,1,1-2.76-2.76A2.76,2.76,0,0,1,223.5,150.34Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.17,
    y: 226.5,
    width: 26.89,
    height: 3.41,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.17,
    y: 237.48,
    width: 126.98,
    height: 57.17,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "340.75 289.75 376.66 253.58 407.8 281.08 424.65 266.04 457.05 289.75 340.75 289.75",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.63,258.87a4.25,4.25,0,1,1-4.25-4.26A4.25,4.25,0,0,1,409.63,258.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.75,289.91a.72.72,0,0,1,0-.23c0-.17,0-.39,0-.67,0-.61,0-1.46-.07-2.57,0-2.27-.08-5.55-.15-9.71-.06-8.35-.16-20.24-.28-34.52l.56.24-115.54,0,.64-.27h0v12.83q0,6.3,0,12.31c0,8,0,15.58-.06,22.54l-.57-.24,83.54.12,23.57.07,6.25,0h2.19a4.44,4.44,0,0,1-.51,0h-1.56l-6.14,0-23.43.06-83.91.13h-.56v-.25c0-7,0-14.53-.07-22.54q0-6,0-12.31c0-2.11,0-4.23,0-6.37v-6.46h0l.66-.29,115.54,0h.56v.24c-.12,14.34-.22,26.29-.29,34.68-.06,4.14-.11,7.4-.14,9.65,0,1.09-.05,1.93-.07,2.53,0,.26,0,.47,0,.64S456.76,289.92,456.75,289.91Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.65,312a5,5,0,1,1-5-5.05A5,5,0,0,1,348.65,312Z",
    style: {
      fill: "#FFAD63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.58,309.29c0,.15-17.66.26-39.44.26s-39.45-.11-39.45-.26,17.66-.26,39.45-.26S431.58,309.15,431.58,309.29Z",
    style: {
      fill: "#FFAD63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.58,312.88c0,.14-17.66.26-39.44.26s-39.45-.12-39.45-.26,17.66-.26,39.45-.26S431.58,312.74,431.58,312.88Z",
    style: {
      fill: "#FFAD63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.85,317.05a11,11,0,0,1-1.65.1l-4.52.08c-3.82,0-9.09.08-14.91.08s-11.09,0-14.91-.08l-4.51-.08a11,11,0,0,1-1.66-.1,10,10,0,0,1,1.66-.11l4.51-.08c3.82-.05,9.09-.07,14.91-.07s11.09,0,14.91.07l4.52.08A10,10,0,0,1,394.85,317.05Z",
    style: {
      fill: "#FFAD63"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 343.61,
    cy: 331.11,
    r: 5.05,
    style: {
      fill: "#FFAD63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.58,328.41c0,.14-17.66.26-39.44.26s-39.45-.12-39.45-.26,17.66-.26,39.45-.26S431.58,328.26,431.58,328.41Z",
    style: {
      fill: "#FFAD63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.58,332c0,.15-17.66.26-39.44.26s-39.45-.11-39.45-.26,17.66-.26,39.45-.26S431.58,331.85,431.58,332Z",
    style: {
      fill: "#FFAD63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.85,336.16a9.48,9.48,0,0,1-1.65.1l-4.52.09c-3.82,0-9.09.07-14.91.07s-11.09,0-14.91-.07l-4.51-.09a9.55,9.55,0,0,1-1.66-.1,9.55,9.55,0,0,1,1.66-.1l4.51-.08c3.82-.05,9.09-.08,14.91-.08s11.09,0,14.91.08l4.52.08A9.48,9.48,0,0,1,394.85,336.16Z",
    style: {
      fill: "#FFAD63"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.86,
    y: 157.25,
    width: 345.61,
    height: 56.76,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356.99,
    y: 176.85,
    width: 80.4,
    height: 5.9,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.53,193.36l-.41,0-1.19,0-4.59.05-16.86.08-55.62.08-55.64-.08-16.86-.08-4.58-.05-1.19,0-.41,0,.41,0,1.19,0,4.58-.05,16.86-.08,55.64-.08,55.62.08,16.86.08,4.59.05,1.19,0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.7,199.54a5.82,5.82,0,0,1-.86.05l-2.48,0-9.11.08-30.05.08-30.06-.08-9.11-.08-2.48,0a5.82,5.82,0,0,1-.86-.05,4.46,4.46,0,0,1,.86,0l2.48-.05,9.11-.09,30.06-.07,30.05.07,9.11.09,2.48.05A4.46,4.46,0,0,1,439.7,199.54Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.86,214a29,29,0,1,1-29-29A29,29,0,0,1,286.86,214Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.6,277.19c0,.15-14.88.28-33.24.28s-33.23-.13-33.23-.28,14.87-.29,33.23-.29S292.6,277,292.6,277.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.6,284.54c0,.15-14.88.28-33.24.28s-33.23-.13-33.23-.28,14.87-.28,33.23-.28S292.6,284.38,292.6,284.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.6,291.89c0,.16-14.88.28-33.24.28s-33.23-.12-33.23-.28,14.87-.28,33.23-.28S292.6,291.74,292.6,291.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.32,299.4c0,.16-8.63.28-19.28.28s-19.27-.12-19.27-.28,8.63-.28,19.27-.28S264.32,299.25,264.32,299.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226.13,
    y: 262.18,
    width: 45.8,
    height: 3.35,
    transform: "translate(498.05 527.72) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.73,236.16a28.07,28.07,0,0,0,36.75,0c-1.53-5.24-5.27-11.46-14.36-12.84a11.37,11.37,0,0,0,6.78-10.53c0-6.3-4.73-11.42-10.63-11.45s-10.7,5.06-10.73,11.35a11.36,11.36,0,0,0,6.81,10.63C245.1,224.7,241.29,231,239.73,236.16Z",
    style: {
      fill: "#FFAD63"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226.13,
    y: 310.88,
    width: 25.68,
    height: 3.13,
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubbles--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M600.14,154.91a3.12,3.12,0,0,0,.64.08l1.87.13a21.77,21.77,0,0,1,3,.41,16.68,16.68,0,0,1,1.91.36l2.14.59a35.18,35.18,0,0,1,10.15,5,35.91,35.91,0,0,1,10,11.12,38.18,38.18,0,0,1,3.5,8A38.56,38.56,0,0,1,634.9,190a39.75,39.75,0,0,1-.09,5c0,.85-.23,1.69-.34,2.54a17.34,17.34,0,0,1-.48,2.55,36,36,0,0,1-3.86,10,35.52,35.52,0,0,1-16.77,15.24A32.66,32.66,0,0,1,601.53,228a31.94,31.94,0,0,1-12.35-1.78l-1.21-.44-.16-.06-.15.07-17.37,8.82.52.44c1.85-5.76,3.65-11.34,5.38-16.69l.06-.21-.15-.15A37.14,37.14,0,0,1,567,202.79a37.9,37.9,0,0,1-1.32-16.14,37.2,37.2,0,0,1,12.4-23.29,33.93,33.93,0,0,1,15.75-7.7l2.7-.46,2-.14,1.22-.09.42-.06h-.42l-1.23,0-2,.08-2.73.41a35.84,35.84,0,0,0-7.3,2.19,38,38,0,0,0-8.68,5.4,37.21,37.21,0,0,0-8,9.68,37.68,37.68,0,0,0-4.7,13.87A38.54,38.54,0,0,0,566.34,203a37.78,37.78,0,0,0,9.26,15.47l-.09-.36-5.4,16.68-.28.85.79-.4L588,226.42h-.3l1.23.46a32.83,32.83,0,0,0,12.63,1.81A33.39,33.39,0,0,0,613.65,226a36.1,36.1,0,0,0,17.08-15.58,36.5,36.5,0,0,0,3.9-10.19,17.86,17.86,0,0,0,.48-2.59c.11-.87.29-1.72.33-2.58a40.17,40.17,0,0,0-1.52-14.55,38,38,0,0,0-3.6-8.1,36.15,36.15,0,0,0-10.2-11.2,35.15,35.15,0,0,0-10.32-5l-2.16-.56a16.61,16.61,0,0,0-1.93-.33,19.62,19.62,0,0,0-3.05-.34l-1.88-.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.28,187.07h2.55l5.55-7.74v-5.08s3.94-.24,3.47,6.41,0,5,0,5,8.36,0,9.05.76c.51.53.73,8.83.82,13.33a4.86,4.86,0,0,1-3.45,4.9,3.5,3.5,0,0,1-.9.13c-2.08,0-12.73-1.7-12.73-1.7h-4.4Z",
    style: {
      fill: "#FFAD63"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "585 185.68 586.56 203.09 590.92 203.09 590.92 186.03 585 185.68",
    style: {
      fill: "#FFAD63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.83,250.47H480.89a6,6,0,0,0-6,6v48.81a6,6,0,0,0,6,6h3.51V329l17.46-17.74h133a6,6,0,0,0,6-6V256.48A6,6,0,0,0,634.83,250.47Z",
    style: {
      fill: "#FFAD63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.13,289.36c-.08-2.77,0-6.88.08-10.55l0,0A11.54,11.54,0,0,1,597,266.35c5.76-5.93,9.62-4.61,11.84-4.57s12.48,2.49,15.38,14.75a21,21,0,0,1,.32,2.38h0c0,.61.11,1.18.16,1.6h0a12.84,12.84,0,0,0,6.7,10.6,25.4,25.4,0,1,0-36.17,11.62A36.07,36.07,0,0,1,594.13,289.36Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.15,290c0-.2,0-.4,0-.61a36.07,36.07,0,0,0,1.07,13.38,25.12,25.12,0,0,0,5.31,2.38c-.08-3.54-.37-8.57-.37-8.57S594.4,295.83,594.15,290Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.47,279.2s-9.39-1.08-10.9-9.87l-.06.05c-.57,1.33-1.59,4.18-1,6.5L595.15,278l-.94.86c-.1,3.67-.16,7.78-.08,10.55,0,.21,0,.41,0,.61.25,5.86,6,6.58,6,6.58a14,14,0,0,0,7.6-2.49s-1.78,4.27-7.5,3.93l-.1-1.44s.29,5,.37,8.57a25.56,25.56,0,0,0,7.62,1.16,25.83,25.83,0,0,0,6.44-.82Zm-11.55,1.42a.75.75,0,0,1,.74-.74.75.75,0,1,1-.74.74Zm-.17-1.27a2,2,0,0,1,1.14-.44,1.91,1.91,0,0,1,1.16.34c.26.19.35.37.31.41s-.67-.3-1.45-.26-1.34.49-1.43.4S603.52,279.56,603.75,279.35ZM595,279.2a2,2,0,0,1,1.14-.44,1.84,1.84,0,0,1,1.16.34c.26.19.35.37.31.41s-.67-.3-1.45-.26-1.34.49-1.43.39S594.8,279.41,595,279.2Zm.42,1.27a.74.74,0,0,1,.75-.73.72.72,0,0,1,.71.76.73.73,0,1,1-1.46,0Zm3.43,6.1a.47.47,0,0,1-.33-.3,1.28,1.28,0,0,1,.09-.85l.54-1.67a29.42,29.42,0,0,1,1.59-4.22,29.9,29.9,0,0,1-1.27,4.33l-.57,1.67a1.18,1.18,0,0,0-.12.64c0,.14.22.18.43.19a4.83,4.83,0,0,1,1.28.2,4.93,4.93,0,0,1-1.3.05A1.08,1.08,0,0,1,598.89,286.57Zm3,2.88a2.15,2.15,0,0,1-2.59-.81c1.6,0,4.63-1.8,3.82-1.27A1.7,1.7,0,0,1,601.88,289.45Z",
    style: {
      fill: "#e5baab"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.92,280.5a.72.72,0,0,0-.71-.76.75.75,0,1,0,.71.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.2,279.25c.78,0,1.37.37,1.45.26s0-.22-.31-.41a1.84,1.84,0,0,0-1.16-.34,2,2,0,0,0-1.14.44c-.24.21-.32.4-.27.44S595.41,279.28,596.2,279.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.38,280.64a.74.74,0,0,0-.72-.76.75.75,0,0,0,0,1.5A.74.74,0,0,0,605.38,280.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.91,279.4c.78,0,1.37.37,1.45.26s-.05-.22-.31-.41a1.91,1.91,0,0,0-1.16-.34,2,2,0,0,0-1.14.44c-.23.21-.31.4-.27.45S604.12,279.43,604.91,279.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.53,286.56a4.83,4.83,0,0,0-1.28-.2c-.21,0-.4-.05-.43-.19a1.18,1.18,0,0,1,.12-.64l.57-1.67a29.9,29.9,0,0,0,1.27-4.33,29.42,29.42,0,0,0-1.59,4.22l-.54,1.67a1.28,1.28,0,0,0-.09.85.47.47,0,0,0,.33.3,1.08,1.08,0,0,0,.34,0A4.93,4.93,0,0,0,600.53,286.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.29,288.64a2.15,2.15,0,0,0,2.59.81,1.7,1.7,0,0,0,1.23-2.08C603.92,286.84,600.89,288.67,599.29,288.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.74,294.06a14,14,0,0,1-7.6,2.49l.1,1.44C606,298.33,607.74,294.06,607.74,294.06Z",
    style: {
      fill: "#d78776"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.67,280.52h0c0-.42-.11-1-.16-1.6h0a21,21,0,0,0-.32-2.38c-2.9-12.26-13.31-14.72-15.38-14.75s-6.08-1.36-11.84,4.57a11.54,11.54,0,0,0-2.77,12.48l0,0,.94-.86,8.39-2.07c-.62-2.32.4-5.17,1-6.5l.06-.05c1.51,8.79,10.9,9.87,10.9,9.87l-.9,26.26c.35-.1.7-.19,1-.3a25.45,25.45,0,0,0,15.76-14A12.84,12.84,0,0,1,624.67,280.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 493.67,
    y: 268.37,
    width: 79.82,
    height: 4.4,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 493.67,
    y: 279.69,
    width: 79.82,
    height: 4.4,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 493.67,
    y: 290.69,
    width: 39.56,
    height: 4.4,
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M627.38,420.59l-1.86-9.47-17.76,3.37,2.58,13.89,1.11-.14c4.95-.66,25.13-3.7,28.22-5.31C643.11,421.12,627.38,420.59,627.38,420.59Z",
    style: {
      fill: "#FFAD63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.75,427a6.29,6.29,0,0,0-3-3.35,6,6,0,0,0-4.39-.5l.94,5Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.12,421.11s5.58.53,5.08,1.52-20.77,4.84-29.86,5.75l-.05-.41L634,423.7S634.09,421.35,635.12,421.11Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610,428l.31,0,.89-.11,3.25-.47c2.75-.42,6.53-1.05,10.69-1.83s7.92-1.58,10.63-2.19l3.21-.75.86-.22.3-.09-.31.05-.87.18-3.22.68c-2.72.57-6.47,1.34-10.64,2.12s-7.94,1.44-10.67,1.89l-3.25.54-.88.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634,424a7.47,7.47,0,0,1,.31-1.66,6.29,6.29,0,0,1,.87-1.44,2.4,2.4,0,0,0-1.08,1.36A2.44,2.44,0,0,0,634,424Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.28,422.31c.06,0,.25-.33.44-.79s.28-.84.22-.87a2,2,0,0,0-.43.79A2.08,2.08,0,0,0,628.28,422.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.7,421.82s.3-.2.55-.54.42-.63.37-.67-.29.21-.55.54S626.65,421.78,626.7,421.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.48,420.32a2.13,2.13,0,0,0,.94-.06,2.16,2.16,0,0,0,.92-.27,2.09,2.09,0,0,0-1,.05A2,2,0,0,0,625.48,420.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.94,419.19a2.6,2.6,0,0,0,2.13-.24,6.28,6.28,0,0,0-1.06.13A6.74,6.74,0,0,0,624.94,419.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.59,420.65a3.55,3.55,0,0,0,1.14-.23,6.5,6.5,0,0,0,1.17-.5,3.27,3.27,0,0,0,.64-.41.63.63,0,0,0,.21-.41.46.46,0,0,0-.25-.43,2.15,2.15,0,0,0-2.48,1.11,2.23,2.23,0,0,0-.23.83.86.86,0,0,0,0,.31,3.79,3.79,0,0,1,.34-1.07A2.11,2.11,0,0,1,630,419a1.84,1.84,0,0,1,1.38-.16c.21.1.18.32,0,.48a3.4,3.4,0,0,1-.59.4,8.44,8.44,0,0,1-1.12.53C629,420.53,628.59,420.61,628.59,420.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.9,420.65a1.16,1.16,0,0,0,0-.82,1.81,1.81,0,0,0-.47-.78,1.18,1.18,0,0,0-1.06-.4.47.47,0,0,0-.25.6,1.29,1.29,0,0,0,.29.47,3.5,3.5,0,0,0,.67.59,1.75,1.75,0,0,0,.74.34s-.27-.17-.65-.47a4.71,4.71,0,0,1-.61-.59c-.2-.21-.39-.63-.11-.73a1,1,0,0,1,.84.34,1.9,1.9,0,0,1,.47.68A4.43,4.43,0,0,1,628.9,420.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.45,423.09s.5-.15,1.32-.2a5.8,5.8,0,0,1,3.09.63,5.88,5.88,0,0,1,2.26,2.19c.42.71.54,1.22.58,1.21a1,1,0,0,0-.07-.36,4.16,4.16,0,0,0-.37-.92,5.49,5.49,0,0,0-5.5-2.91,4.77,4.77,0,0,0-1,.21A1.25,1.25,0,0,0,609.45,423.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.89,415.35a30.94,30.94,0,0,0,.54,3.68,29.44,29.44,0,0,0,.75,3.63,30.94,30.94,0,0,0-.54-3.67A30.43,30.43,0,0,0,609.89,415.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.66,424.86a10.08,10.08,0,0,0,2.64-.23,10.54,10.54,0,0,0,2.55-.7c0-.07-1.16.23-2.59.48S618.65,424.8,618.66,424.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.17,425.51c0,.05.14.23.31.47s.28.47.34.46,0-.3-.16-.58S615.2,425.46,615.17,425.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.55,424.13c0,.05.12.21.34.36s.42.24.46.19-.12-.22-.34-.37S613.59,424.08,613.55,424.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.53,423.74c0,.06.26,0,.54.05s.49.15.53.1-.15-.27-.5-.32S611.51,423.69,611.53,423.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.13,423.64c0,.06.11.13.27.16s.29,0,.3-.06-.1-.13-.26-.16S610.14,423.58,610.13,423.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.52,402.84s24.57-55,47.68-55.47c0,0,13.33-3,18.55,24.17,2.61,13.63,11.39,46.36,11.39,46.36l-23.33,4-8.72-40.62L585,406.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "603.23 419.9 603.93 422.87 629.29 418.07 628.71 414.95 603.23 419.9",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.7,369.85c0,.13-.35.38-.89.53s-1.06.1-1-.06.38-.28.91-.44S587.66,369.71,587.7,369.85Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.51,368.44a7,7,0,0,1-2,.28c-1.07.12-2,.22-2,.07s.82-.47,1.94-.59S595.53,368.29,595.51,368.44Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.84,374.4c-.14,0-.54-.76-.89-1.8a4.2,4.2,0,0,1-.4-2c.13-.06.53.74.89,1.8S600,374.36,599.84,374.4Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602,382.09c-.14,0-.48-.8-.77-1.86s-.4-2-.26-2,.48.8.77,1.86S602.1,382.05,602,382.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.91,389.83c-.14,0-.47-.8-.74-1.87s-.36-2-.22-2,.46.8.73,1.87A4.29,4.29,0,0,1,603.91,389.83Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.77,397.58c-.14,0-.46-.8-.72-1.88s-.35-2-.21-2,.46.81.72,1.88S605.91,397.55,605.77,397.58Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.57,405.36c-.14,0-.45-.81-.7-1.89s-.33-2-.19-2,.45.81.7,1.88S607.72,405.32,607.57,405.36Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.34,413.14c-.14,0-.45-.81-.69-1.89s-.33-2-.19-2,.45.81.7,1.89S609.48,413.11,609.34,413.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.64,419c-.14,0-.35-.38-.47-.92s-.1-1,0-1,.35.38.47.92S610.78,419,610.64,419Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.12,326.93h0l-3.11.25-8.55,19.34,5.26,21.19c2.81,9.83-5.09,22.37-6.44,31.12L544.76,400,547,370.07l1.52,13.27,19.67,2.48L557.6,348.43c-5.7-21.53-24.17-21.3-24.17-21.3",
    style: {
      fill: "#FFAD63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.32,326.92c-.29-1.68.35-7.82.35-7.82s6.44-.68,6.83-7.06,0-21.09,0-21.09l-11.72-5.73-11.08,9.87.14,31.79Z",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.72,301.61a.82.82,0,1,1-.82-.82A.82.82,0,0,1,537.72,301.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.91,301c-.1.11-.71-.4-1.59-.45s-1.54.38-1.63.26.07-.25.36-.45a2.2,2.2,0,0,1,1.31-.34,2.15,2.15,0,0,1,1.26.5C538.88,300.77,539,301,538.91,301Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.22,301.46a.82.82,0,1,1-.82-.82A.82.82,0,0,1,528.22,301.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.41,300.87c-.1.11-.71-.4-1.58-.45s-1.54.38-1.64.26.07-.25.36-.45a2.2,2.2,0,0,1,1.31-.34,2.12,2.12,0,0,1,1.26.5C529.38,300.62,529.46,300.83,529.41,300.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.43,308.21a5.79,5.79,0,0,1,1.44-.19c.22,0,.44,0,.49-.2a1.26,1.26,0,0,0-.13-.71l-.6-1.82a32.55,32.55,0,0,1-1.34-4.75,34.52,34.52,0,0,1,1.69,4.64l.57,1.83a1.42,1.42,0,0,1,.09.92.6.6,0,0,1-.38.32,1.76,1.76,0,0,1-.38,0A6,6,0,0,1,532.43,308.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.53,309a9.63,9.63,0,0,0,4.25,1.46,2.44,2.44,0,0,1-2.92.83C529,310.54,529.53,309,529.53,309Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.67,319.1a15.9,15.9,0,0,1-8.45-2.85s1.91,4.68,8.31,4.42Z",
    style: {
      fill: "#a36957"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.21,301.61c0-.3.1-.76.16-1.29s0-.62,0-.62h0c.13-1.24.28-2.64.38-3.25,2.72-16.79,16.88-15.8,16.88-15.8.77,0,5.27-.39,10.81,3.49a15.32,15.32,0,0,1,7.11,12.52,13.62,13.62,0,0,1-.17,2.67,3.13,3.13,0,0,1-.25.95c-.1,0,.19-1.39,0-3.6a16.45,16.45,0,0,0-1.09-4.79,12.09,12.09,0,0,1-.48,8l-11.37-1.77c.73-2.5.2-6.45-.14-8.38-2,9.28-10,13.74-10,13.74l-.95-.15v14.13c-9.67-2.06-10.84-11.68-10.88-15.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.75,297a8.07,8.07,0,0,0-11.17-.85,4.31,4.31,0,0,0-1.44,1.92,2.31,2.31,0,0,0,.4,2.28,1.59,1.59,0,0,0,2.18.13A1.84,1.84,0,1,0,499,303a4.47,4.47,0,0,0-.32,1.84,1.77,1.77,0,0,0,1,1.49,1.93,1.93,0,0,0,2-.66,14.89,14.89,0,0,0,1.24-1.88,6,6,0,0,1,5-2.56",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497,292.22a3.56,3.56,0,0,1,1.67-.33,8.35,8.35,0,0,1,7.13,3.57,3.58,3.58,0,0,1,.74,1.53c-.08,0-.38-.53-1-1.31a9.72,9.72,0,0,0-3.06-2.44,9.61,9.61,0,0,0-3.78-1A13.79,13.79,0,0,1,497,292.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.86,296.58a12.83,12.83,0,0,1-.19,2.93,12.53,12.53,0,0,1-.35,2.9,9.93,9.93,0,0,1,.54-5.83Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.55,306.57a2.6,2.6,0,0,1-3.27-.45,3.8,3.8,0,0,1-.84-3.36,2.9,2.9,0,0,1,1-1.85,3,3,0,0,1,2.82.17Z",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.11,305.56c0-.09-.31-.14-.68-.41a1.63,1.63,0,0,1,.26-2.82c.42-.2.74-.19.75-.27s-.32-.23-.88-.09a1.9,1.9,0,0,0-.32,3.51C515.76,305.72,516.12,305.62,516.11,305.56Z",
    style: {
      fill: "#a36957"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.72,305.61a2.06,2.06,0,0,0-1.16.72,1.59,1.59,0,0,0-.28,1.4,1.65,1.65,0,0,0,3.2-.77,4,4,0,0,0-.54-1.29s.11.08.26.29a2.54,2.54,0,0,1,.42,1,1.79,1.79,0,0,1-.35,1.54,1.89,1.89,0,0,1-1.81.66,1.93,1.93,0,0,1-1.37-1.35,1.73,1.73,0,0,1,.35-1.54A1.54,1.54,0,0,1,513.72,305.61Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.81,327.11s-9.58.15-14.46,12.82a26.86,26.86,0,0,0-.06,18.58l1.75,4.93,19.37-5.61Z",
    style: {
      fill: "#FFAD63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.16,377.84a7,7,0,0,1-.07-1.33,33.13,33.13,0,0,1,.16-3.63,37.09,37.09,0,0,1,.91-5.32c.45-2,1.22-4.1,1.79-6.33a11.4,11.4,0,0,0-.34-6.35,34.67,34.67,0,0,0-2.05-4.92l-1.66-3.22a5.34,5.34,0,0,1-.55-1.21,6.52,6.52,0,0,1,.73,1.11c.44.73,1.08,1.8,1.81,3.15a30.85,30.85,0,0,1,2.18,4.95,15.41,15.41,0,0,1,.67,3.15,10.22,10.22,0,0,1-.29,3.46c-.58,2.29-1.35,4.37-1.83,6.33a42.22,42.22,0,0,0-1,5.24c-.19,1.51-.28,2.75-.33,3.6A6.18,6.18,0,0,1,546.16,377.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 516.41,
    y: 323.27,
    width: 16.28,
    height: 3.84,
    style: {
      fill: "#FFAD63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536,398.83a7.2,7.2,0,0,1-.09-.73q-.06-.8-.15-2.1c-.12-1.89-.3-4.51-.51-7.74-.42-6.53-1-15.54-2-25.48s-2.1-18.91-3-25.38c-.48-3.2-.88-5.8-1.16-7.67-.13-.86-.23-1.55-.31-2.08a4,4,0,0,1-.07-.73,3.94,3.94,0,0,1,.17.71c.11.52.24,1.21.41,2.07.35,1.8.8,4.41,1.32,7.64,1,6.47,2.25,15.44,3.2,25.39s1.51,19,1.84,25.51c.17,3.27.28,5.92.34,7.75,0,.87,0,1.57.06,2.11A3.14,3.14,0,0,1,536,398.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.32,323.31a1.89,1.89,0,0,1,.17.67,9.36,9.36,0,0,1,.14,1.9,4.63,4.63,0,0,1-.94,2.71,3.37,3.37,0,0,1-1.42,1,5.3,5.3,0,0,1-1.82.29,14.3,14.3,0,0,1-6-1.59,7,7,0,0,1-2.12-1.46c0-.07.85.49,2.28,1.13a16,16,0,0,0,5.88,1.4,3.54,3.54,0,0,0,2.87-1.1,4.39,4.39,0,0,0,.94-2.43C528.38,324.31,528.22,323.31,528.32,323.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.83,326.56c.07,0,.1.65-.51,1.41a2.65,2.65,0,0,1-1.37,1,2,2,0,0,1-1.05-.08,2.13,2.13,0,0,1-1-.56,3.14,3.14,0,0,1-.75-1.93,13.24,13.24,0,0,1,0-1.61,3.76,3.76,0,0,1,.19-1.47,4.8,4.8,0,0,1,.18,1.46c0,.45.07,1,.16,1.56a2.88,2.88,0,0,0,.64,1.63,1.63,1.63,0,0,0,.74.43,1.85,1.85,0,0,0,.8.11,2.66,2.66,0,0,0,1.2-.77A5.48,5.48,0,0,0,532.83,326.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.6,337.16c-.06,0-.65-.89-1.63-1.81s-2-1.44-1.92-1.5a5.83,5.83,0,0,1,2.06,1.35A6.06,6.06,0,0,1,503.6,337.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.47,335.7a2.9,2.9,0,0,1-.32-1.42,4.82,4.82,0,0,1,.06-1.46,5.29,5.29,0,0,1,.15,1.45C502.39,335.06,502.52,335.69,502.47,335.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.83,336.11a2.65,2.65,0,0,1-1,.29,2.77,2.77,0,0,1-1,.1,2.56,2.56,0,0,1,1-.3A2.43,2.43,0,0,1,502.83,336.11Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.24,361.2c-.06,0-.65-.9-1.63-1.81s-2-1.45-1.92-1.5a5.66,5.66,0,0,1,2.06,1.35A6.06,6.06,0,0,1,543.24,361.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.11,359.74a2.84,2.84,0,0,1-.32-1.43,4.78,4.78,0,0,1,.06-1.45,5.76,5.76,0,0,1,.15,1.44C542,359.1,542.16,359.72,542.11,359.74Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.47,360.14a2.56,2.56,0,0,1-1,.3,2.43,2.43,0,0,1-1,.09,2.65,2.65,0,0,1,1-.29A2.78,2.78,0,0,1,542.47,360.14Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.92,395.23a23.73,23.73,0,0,0-1.63-1.81c-1-.93-1.94-1.45-1.91-1.51a6.11,6.11,0,0,1,2.06,1.35A5.65,5.65,0,0,1,508.92,395.23Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.79,393.77a2.94,2.94,0,0,1-.31-1.43,4.86,4.86,0,0,1,.06-1.46,6.11,6.11,0,0,1,.14,1.45C507.72,393.12,507.84,393.75,507.79,393.77Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.15,394.17a2.47,2.47,0,0,1-1,.3,2.9,2.9,0,0,1-1,.09,2.56,2.56,0,0,1,1-.3A2.38,2.38,0,0,1,508.15,394.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.9,352.55c0-.05.84-.72,1.66-1.79s1.26-2.07,1.32-2a7.27,7.27,0,0,1-3,3.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.25,351.29a2.89,2.89,0,0,1,1.4-.44,4.66,4.66,0,0,1,1.45-.08,5.17,5.17,0,0,1-1.42.28C523.89,351.16,523.28,351.34,523.25,351.29Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.88,351.69a2.88,2.88,0,0,1-.38-.95,2.36,2.36,0,0,1-.18-1,2.66,2.66,0,0,1,.38.94A2.38,2.38,0,0,1,522.88,351.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.69,345.38c0,.06-1-.44-2.33-.71s-2.41-.24-2.41-.3a5.74,5.74,0,0,1,2.46.1A5.82,5.82,0,0,1,553.69,345.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552,344.71a2.85,2.85,0,0,1-1-1.06,4.22,4.22,0,0,1-.7-1.28,6.54,6.54,0,0,1,.87,1.17C551.58,344.2,552,344.67,552,344.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.49,344.87s-.27.38-.69.76a2.6,2.6,0,0,1-.82.6s.27-.38.69-.76A2.6,2.6,0,0,1,552.49,344.87Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.08,338c0-.05.83-.72,1.65-1.79s1.26-2.07,1.32-2a5.8,5.8,0,0,1-1.15,2.17A6.13,6.13,0,0,1,518.08,338Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.43,336.78a2.89,2.89,0,0,1,1.39-.45,4.89,4.89,0,0,1,1.46-.07,5.3,5.3,0,0,1-1.43.28C520.06,336.65,519.45,336.83,519.43,336.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.06,337.18a2.46,2.46,0,0,1-.38-.95,2.71,2.71,0,0,1-.19-1,2.57,2.57,0,0,1,.39.95A2.82,2.82,0,0,1,519.06,337.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.44,364.7c0-.05.83-.72,1.65-1.78s1.27-2.08,1.33-2.05a5.84,5.84,0,0,1-1.16,2.17A5.72,5.72,0,0,1,554.44,364.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.79,363.44a3.08,3.08,0,0,1,1.39-.44,4.53,4.53,0,0,1,1.46-.07,5.94,5.94,0,0,1-1.43.27C556.43,363.31,555.81,363.49,555.79,363.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.42,363.84a2.66,2.66,0,0,1-.38-.95,2.7,2.7,0,0,1-.19-1,2.47,2.47,0,0,1,.39.94A2.58,2.58,0,0,1,555.42,363.84Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.5,337.81c0-.05.84-.73,1.66-1.79s1.26-2.07,1.32-2a7.27,7.27,0,0,1-3,3.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.85,336.55a3,3,0,0,1,1.4-.45,4.83,4.83,0,0,1,1.45-.07,5.64,5.64,0,0,1-1.42.28C539.49,336.41,538.88,336.6,538.85,336.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.48,336.94a2.66,2.66,0,0,1-.38-.94,2.38,2.38,0,0,1-.18-1,2.88,2.88,0,0,1,.38.95A2.36,2.36,0,0,1,538.48,336.94Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528,366.09c0,.07-1.08-.21-2.43-.2s-2.41.28-2.42.21a7.29,7.29,0,0,1,4.85,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.15,365.8a2.82,2.82,0,0,1-1.21-.82,4.77,4.77,0,0,1-1-1.1,5.59,5.59,0,0,1,1.09.95C525.65,365.38,526.17,365.75,526.15,365.8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.69,365.85a2.89,2.89,0,0,1-.51.88,2.77,2.77,0,0,1-.68.77s.18-.43.51-.89S526.64,365.82,526.69,365.85Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.21,349.36c0-.05.16-.22.46-.06a.55.55,0,0,1,.27.54.64.64,0,0,1-.52.54.59.59,0,0,1-.69-.43.57.57,0,0,1,.17-.59l.1-.08.07,0c.18.09.28.18.26.24s-.14.09-.35.09l.17-.05c0,.11.07.34.17.28s.21-.14.12-.28S534.23,349.43,534.21,349.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.31,362.81c0-.06.16-.23.46-.06a.53.53,0,0,1,.27.53.63.63,0,0,1-.52.54.6.6,0,0,1-.52-1l.11-.08.06,0c.18.09.28.18.26.24s-.14.1-.34.09l.16-.05c0,.11.07.34.17.28s.21-.14.12-.28S535.33,362.87,535.31,362.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.21,374.69c0-.06.16-.23.47-.06a.58.58,0,0,1,.27.54.66.66,0,0,1-.52.54.6.6,0,0,1-.69-.44.55.55,0,0,1,.16-.58l.11-.08.06,0c.18.09.28.18.27.24s-.15.09-.35.09l.17-.05c0,.11.07.34.17.28s.2-.14.12-.28S536.24,374.76,536.21,374.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.2,336.8c0-.06.16-.23.46-.06a.53.53,0,0,1,.27.53.63.63,0,0,1-.52.54.58.58,0,0,1-.69-.43.57.57,0,0,1,.17-.59l.1-.08.06,0c.19.09.29.18.27.24s-.14.1-.35.09l.17-.05c0,.11.07.34.17.28s.21-.14.12-.28S532.22,336.86,532.2,336.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.11,397.89s-10.08,27.86,14.41,29c21.89,1,51.05.91,62.21.89,5.25,0,9.45.85,14.23-1.31,5.2-2.34,10.49-6.19,10.91-12.25.55-7.86-4.67-15.28-22.88-16.32S499.11,397.89,499.11,397.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.54,399.71c-.14,0-.1-.51.08-1s.43-.92.57-.87.1.51-.08,1S503.68,399.75,503.54,399.71Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.24,407.63c-.14,0-.34-.9-.26-2a3.54,3.54,0,0,1,.51-2c.15,0,.08.93,0,2A5.49,5.49,0,0,1,502.24,407.63Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.55,414.79c-.08.11-.89-.4-1.56-1.34s-.92-1.86-.79-1.91.58.72,1.21,1.6S505.65,414.68,505.55,414.79Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513,417.66c0,.14-.94.12-2-.14s-1.93-.67-1.88-.81a5.18,5.18,0,0,1,2,.3C512.16,417.26,513,417.52,513,417.66Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.06,418.24c0,.15-.91.25-2,.23s-2-.19-2-.33.91-.22,2-.19A4.26,4.26,0,0,1,521.06,418.24Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.15,418.33c0,.15-.91.25-2,.24s-2-.13-2-.28a8,8,0,0,1,4,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.24,418.37c0,.15-.9.26-2,.26a4.26,4.26,0,0,1-2-.27,4.11,4.11,0,0,1,2-.25A4.18,4.18,0,0,1,537.24,418.37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.33,418.37c0,.15-.91.26-2,.27a4.18,4.18,0,0,1-2-.26c0-.15.9-.26,2-.26A4.14,4.14,0,0,1,545.33,418.37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.41,418.33c0,.15-.9.27-2,.28a4.31,4.31,0,0,1-2-.25c0-.15.91-.27,2-.27A4.18,4.18,0,0,1,553.41,418.33Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.5,418.27a4.19,4.19,0,0,1-2,.28c-1.11,0-2-.1-2-.25a4.26,4.26,0,0,1,2-.27C560.6,418,561.5,418.12,561.5,418.27Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.59,418.19a4.22,4.22,0,0,1-2,.28,4.27,4.27,0,0,1-2-.24c0-.15.91-.27,2-.28S569.58,418,569.59,418.19Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.67,418.1a4.19,4.19,0,0,1-2,.28c-1.12,0-2-.09-2-.24s.9-.27,2-.28A4.24,4.24,0,0,1,577.67,418.1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.75,418c0,.15-.9.27-2,.28a4.18,4.18,0,0,1-2-.24,8,8,0,0,1,4,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.83,418c0,.15-.9.27-2,.28a4.29,4.29,0,0,1-2-.25,4.12,4.12,0,0,1,2-.27A4.18,4.18,0,0,1,593.83,418Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.87,417.94c0,.14-.45.26-1,.26s-1-.11-1-.25.45-.27,1-.27S599.87,417.8,599.87,417.94Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.58,419.91l-.3,0-.88,0L594,420l-12.42.14c-10.5.11-25,.26-41,.18-8-.05-15.63-.15-22.57-.28a47.26,47.26,0,0,1-9.85-.77,10.17,10.17,0,0,1-4.14-1.79,12.69,12.69,0,0,1-2.76-3.13,8.32,8.32,0,0,1-.93-3.67,25.16,25.16,0,0,1,0-3.36,28.2,28.2,0,0,1,1-5.27c.38-1.42.74-2.5,1-3.23.11-.35.21-.62.28-.83s.11-.29.12-.28a1,1,0,0,1-.07.29l-.23.85c-.21.74-.54,1.83-.9,3.25a29.08,29.08,0,0,0-.87,5.24,24.85,24.85,0,0,0,.05,3.32,8,8,0,0,0,.92,3.51,12.6,12.6,0,0,0,2.69,3,9.82,9.82,0,0,0,4,1.68,48.21,48.21,0,0,0,9.76.71c6.93.11,14.56.19,22.57.23,16,.09,30.5,0,41,0l12.43,0,3.38,0,.88,0A1.71,1.71,0,0,1,598.58,419.91Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550,392.66s-51,4.61-54-18.79c-3.24-24.83-1.56-28-1.56-28l19.62.22s1,23.78,3.2,25.07c9.58,5.72,26.16,7.5,31.71,7.49Z",
    style: {
      fill: "#FFAD63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550,392.66a6.1,6.1,0,0,1-.14-1c-.07-.69-.15-1.62-.27-2.79-.21-2.48-.5-6-.86-10.19l.18.18a165,165,0,0,1-22.68-3.51c-2.47-.56-5-1.22-7-2.77a11,11,0,0,1-3.74-5.9,26.84,26.84,0,0,1-.94-6.24c-.15-1.95-.29-3.78-.42-5.45-.22-3.34-.34-6.05-.36-7.92q0-1.41,0-2.16a5,5,0,0,1,.06-.75,4.16,4.16,0,0,1,0,.76c0,.54,0,1.25.07,2.15.08,1.86.26,4.56.53,7.89.15,1.67.31,3.49.48,5.45a26.72,26.72,0,0,0,1,6.14,11.21,11.21,0,0,0,3.59,5.63,16.82,16.82,0,0,0,6.77,2.66,179.44,179.44,0,0,0,22.6,3.62h.17v.17c.29,4.25.52,7.73.69,10.21.07,1.17.12,2.11.16,2.8A6.72,6.72,0,0,1,550,392.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.75,392.6a3.22,3.22,0,0,1-.67.15c-.45.07-1.1.22-2,.31a52.57,52.57,0,0,1-7.22.4,118.85,118.85,0,0,1-23.64-2.91,43.51,43.51,0,0,1-12.44-4.23,21.82,21.82,0,0,1-4.64-3.43,18.18,18.18,0,0,1-3-4,14,14,0,0,1-1.92-6.95,9.18,9.18,0,0,1,.35-2.63c.07,0-.18.94-.15,2.63a14.36,14.36,0,0,0,2,6.77,18.41,18.41,0,0,0,3,3.87,21.25,21.25,0,0,0,4.56,3.32A44.67,44.67,0,0,0,517.38,390a128.57,128.57,0,0,0,23.54,3.06,63.9,63.9,0,0,0,7.19-.24c.85-.06,1.5-.17,1.95-.21A3.24,3.24,0,0,1,550.75,392.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.07,350.18a23.73,23.73,0,0,0-1.63-1.81c-1-.92-1.95-1.45-1.92-1.51a6,6,0,0,1,2.06,1.36A5.78,5.78,0,0,1,510.07,350.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.94,348.72a3,3,0,0,1-.32-1.43,4.74,4.74,0,0,1,.06-1.45,5.18,5.18,0,0,1,.15,1.44C508.86,348.07,509,348.7,508.94,348.72Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.3,349.12a2.56,2.56,0,0,1-1,.3,2.59,2.59,0,0,1-1,.09,2.39,2.39,0,0,1,1-.3A2.64,2.64,0,0,1,509.3,349.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.41,382s8.52-.15,9.84,2.28,2.55,8,2.55,8l-11.65-.46Z",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.37,387.09s.84-.72,1.66-1.79,1.26-2.07,1.32-2a7.27,7.27,0,0,1-3,3.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.73,385.83a2.89,2.89,0,0,1,1.39-.44,4.65,4.65,0,0,1,1.45-.08,5.17,5.17,0,0,1-1.42.28C540.36,385.7,539.75,385.88,539.73,385.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.36,386.23a4.84,4.84,0,0,1-.57-2,2.46,2.46,0,0,1,.38.94A2.71,2.71,0,0,1,539.36,386.23Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.34,380.66c0-.05.83-.73,1.65-1.79s1.26-2.07,1.32-2a5.92,5.92,0,0,1-1.16,2.17A6,6,0,0,1,504.34,380.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.69,379.4a2.84,2.84,0,0,1,1.39-.45,4.82,4.82,0,0,1,1.45-.07,5.51,5.51,0,0,1-1.42.28C506.32,379.27,505.71,379.45,505.69,379.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.32,379.79a2.38,2.38,0,0,1-.39-.94,2.58,2.58,0,0,1-.18-1,2.66,2.66,0,0,1,.38,1A2.7,2.7,0,0,1,505.32,379.79Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.33,382c-.06,0-.58-.94-1.5-1.92s-1.84-1.58-1.8-1.64a5.92,5.92,0,0,1,2,1.5A6.11,6.11,0,0,1,526.33,382Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.3,380.43a3,3,0,0,1-.21-1.44,4.79,4.79,0,0,1,.17-1.45,5.78,5.78,0,0,1,0,1.45A14.37,14.37,0,0,1,525.3,380.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.63,380.86a2.49,2.49,0,0,1-1,.23,2.93,2.93,0,0,1-1,0,2.49,2.49,0,0,1,1-.23A2.67,2.67,0,0,1,525.63,380.86Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.9,363.8s-.57-.94-1.49-1.93-1.84-1.58-1.8-1.63a7.19,7.19,0,0,1,3.29,3.56Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.88,362.26a2.87,2.87,0,0,1-.21-1.45,4.89,4.89,0,0,1,.16-1.44,5,5,0,0,1,.05,1.45C501.85,361.61,501.93,362.25,501.88,362.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.21,362.69a2.39,2.39,0,0,1-1,.22,2.52,2.52,0,0,1-1,0,5.2,5.2,0,0,1,2-.24Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500,343.68a11.65,11.65,0,0,1,.85-1.22,12.85,12.85,0,0,1,.82-1.23,3.53,3.53,0,0,1-.65,1.35A3.61,3.61,0,0,1,500,343.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.09,336.54a6.8,6.8,0,0,1-.83-1.4,6.68,6.68,0,0,1-.65-1.49,6.55,6.55,0,0,1,.83,1.39A6.44,6.44,0,0,1,511.09,336.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522,345.68a10.68,10.68,0,0,1,1.37-1.64,10.23,10.23,0,0,1,1.53-1.5,11.77,11.77,0,0,1-1.38,1.64A11.15,11.15,0,0,1,522,345.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.49,359a2.75,2.75,0,0,1-1.33-.69,2.86,2.86,0,0,1-.92-1.19c.06,0,.43.51,1.06,1S523.52,358.92,523.49,359Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.23,359.64a3.62,3.62,0,0,1,.2-1.19,3.83,3.83,0,0,1,.39-1.15,3.49,3.49,0,0,1-.19,1.2A3.41,3.41,0,0,1,529.23,359.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.26,371.27a5.88,5.88,0,0,1-1.24-.92,5.41,5.41,0,0,1-1.1-1.09,6.17,6.17,0,0,1,1.24.93A5.53,5.53,0,0,1,522.26,371.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.08,374a2.23,2.23,0,0,1-.1-.95,2.2,2.2,0,0,1,.1-.94,2.11,2.11,0,0,1,.11.94A2.14,2.14,0,0,1,530.08,374Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.18,369.45a8.69,8.69,0,0,1-1.69.81,7.88,7.88,0,0,1-1.78.62,9.32,9.32,0,0,1,1.7-.81A7.72,7.72,0,0,1,543.18,369.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.7,359.32a5.32,5.32,0,0,1-.06-1.4,4.85,4.85,0,0,1,.15-1.39,9.32,9.32,0,0,1-.09,2.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.92,351.39a3.08,3.08,0,0,1-1.5-.51,3,3,0,0,1-1.19-1.05s.55.45,1.29.87S540.93,351.33,540.92,351.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.92,340.22a7.16,7.16,0,0,1,1.16-1.25,6.37,6.37,0,0,1,1.3-1.09,6.92,6.92,0,0,1-1.16,1.24A7.12,7.12,0,0,1,541.92,340.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.33,331a4,4,0,0,1-1.19-.2,3.2,3.2,0,0,1-1.14-.4,4,4,0,0,1,1.19.2A3.2,3.2,0,0,1,537.33,331Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.62,327.17a3,3,0,0,1,.59-.95,3.24,3.24,0,0,1,.77-.83,3.35,3.35,0,0,1-.6.95A3.31,3.31,0,0,1,522.62,327.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.07,334.52a4.74,4.74,0,0,1-.87-1.17,5,5,0,0,1-.7-1.28,5,5,0,0,1,.87,1.17A5.91,5.91,0,0,1,527.07,334.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517,349.05a6.63,6.63,0,0,1-.2-1.67,6.47,6.47,0,0,1,0-1.68,7.46,7.46,0,0,1,.19,1.67A6.84,6.84,0,0,1,517,349.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.56,355.18a4.15,4.15,0,0,1-1.12-.65,3.92,3.92,0,0,1-1-.81,4.11,4.11,0,0,1,1.12.64A4.05,4.05,0,0,1,555.56,355.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.52,369.93a4.78,4.78,0,0,1,.29-1.42,5.55,5.55,0,0,1,.49-1.37,4.72,4.72,0,0,1-.29,1.42A5.55,5.55,0,0,1,550.52,369.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.09,374.21a6.23,6.23,0,0,1-1.45-.69,5.89,5.89,0,0,1-1.34-.88,6.09,6.09,0,0,1,1.44.7A6.31,6.31,0,0,1,556.09,374.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.55,393a7.28,7.28,0,0,1-1.27,1.16,7.2,7.2,0,0,1-1.39,1,7,7,0,0,1,1.26-1.16A6.91,6.91,0,0,1,515.55,393Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.18,395.83a4.36,4.36,0,0,1-1-.88,4.17,4.17,0,0,1-.8-1,8,8,0,0,1,1.76,1.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.16,388.58a2.84,2.84,0,0,1-2.22,1.27c0-.06.55-.2,1.16-.55S504.11,388.54,504.16,388.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502,352.75a8.55,8.55,0,0,1-1.46-1.09,7.7,7.7,0,0,1-1.33-1.26,8.76,8.76,0,0,1,1.46,1.1A7.44,7.44,0,0,1,502,352.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.62,357.73a10,10,0,0,1-1.38,1.47,9.82,9.82,0,0,1-1.53,1.31,9.68,9.68,0,0,1,1.38-1.46A10.27,10.27,0,0,1,510.62,357.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.39,371.94a6.24,6.24,0,0,1-1.75-1,6.54,6.54,0,0,1-1.49-1.35,17.75,17.75,0,0,1,1.61,1.18C502.65,371.42,503.42,371.89,503.39,371.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.86,375.52a11.75,11.75,0,0,1-.45-2.21,12,12,0,0,1-.24-2.25,11.75,11.75,0,0,1,.45,2.21A12,12,0,0,1,513.86,375.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.84,385a6.36,6.36,0,0,1-1.82.66,6,6,0,0,1-1.92.25c0-.05.84-.2,1.87-.45A17.21,17.21,0,0,1,518.84,385Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.1,382.33a12.43,12.43,0,0,1-.93,2.05,11.11,11.11,0,0,1-1.11,2,12.86,12.86,0,0,1,.93-2A11.11,11.11,0,0,1,533.1,382.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.16,389.25a6.4,6.4,0,0,1-1.34.92,6.08,6.08,0,0,1-1.45.75,6.4,6.4,0,0,1,1.34-.92A6.08,6.08,0,0,1,546.16,389.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.23,348.72a7.32,7.32,0,0,1,1.33-.28c.88-.16,2.18-.38,3.78-.62l.21,0,0,.22c.24,1.7.5,3.66.79,5.77l0,.13-.09.09-.46.44L542,356.16l-.14.13-.16-.08c-1.05-.56-2.06-1.08-3-1.56l-.11-.06v-.12c-.17-1.77-.28-3.23-.34-4.23a9.65,9.65,0,0,1-.06-1.52,12,12,0,0,1,.29,1.63c.15,1,.35,2.41.56,4.07l-.12-.17,3,1.5-.3.05,1.81-1.74.46-.44-.08.23-.71-5.78.25.18c-1.51.18-2.77.3-3.68.38A10.46,10.46,0,0,1,538.23,348.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.3,350.56a8.12,8.12,0,0,1-2.51.31,6.72,6.72,0,0,1-2.35,0,11.49,11.49,0,0,1,4.86-.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "531.63 397.24 531.63 395.49 552.33 392.57 562.59 366.69 601.86 366.69 587.83 397.26 531.63 397.24",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.18,382.4a2,2,0,1,1-.62-2.75A2,2,0,0,1,579.18,382.4Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.63,440.67l5.28-5.66-10.54-10-7.81,8.2.62.66c2.75,2.91,14.21,14.59,16.72,15.84C113.69,451.14,106.63,440.67,106.63,440.67Z",
    style: {
      fill: "#FFAD63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.46,436.78a5,5,0,0,0,.78-3.52,4.89,4.89,0,0,0-1.74-3.09l-2.78,2.94Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.93,445.94s2.29,3.87,1.41,4-12.91-11.23-17.78-16.71l.24-.22,13.92,13.39S109.29,445.39,109.93,445.94Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.64,432.87l.17.19.49.52,1.83,1.9c1.56,1.58,3.75,3.75,6.22,6.08s4.75,4.41,6.42,5.88l2,1.73.55.46c.12.11.19.16.2.15l-.18-.17-.53-.49-2-1.77c-1.65-1.5-3.91-3.58-6.38-5.91s-4.67-4.49-6.25-6.05l-1.87-1.85-.52-.5A1,1,0,0,0,93.64,432.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.56,446.58a5.79,5.79,0,0,1,1.22-.58,5.62,5.62,0,0,1,1.35-.11,2,2,0,0,0-1.39-.06A2,2,0,0,0,107.56,446.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.94,442.06a1.46,1.46,0,0,0,.72-.09c.38-.09.68-.21.67-.26s-.33,0-.72.09A1.72,1.72,0,0,0,105.94,442.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.52,440.8c0,.05.27.1.6.11a1.21,1.21,0,0,0,.61-.07s-.27-.1-.6-.11A1.21,1.21,0,0,0,105.52,440.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.92,439.3s.18.3.48.59.57.5.61.46-.19-.3-.49-.59S106,439.27,105.92,439.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.4,438.42c-.05,0,.11.4.44.76a1.48,1.48,0,0,0,.71.52s-.27-.29-.58-.64A6.8,6.8,0,0,0,106.4,438.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.17,441.48a3.09,3.09,0,0,0,.68.64,6,6,0,0,0,.87.52,2.94,2.94,0,0,0,.57.22.49.49,0,0,0,.37-.05.37.37,0,0,0,.15-.37,1.7,1.7,0,0,0-1.87-1.09,1.81,1.81,0,0,0-.65.24c-.14.09-.2.16-.19.17a2.7,2.7,0,0,1,.85-.29,1.66,1.66,0,0,1,.94.18,1.42,1.42,0,0,1,.75.81c0,.18-.13.27-.32.23a2.62,2.62,0,0,1-.53-.2,5.76,5.76,0,0,1-.87-.48C107.45,441.7,107.19,441.46,107.17,441.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.31,441.68s.27-.06.53-.4a1.59,1.59,0,0,0,.28-.67.93.93,0,0,0-.24-.87.36.36,0,0,0-.5.11.9.9,0,0,0-.17.41,2.73,2.73,0,0,0-.07.72,1.3,1.3,0,0,0,.13.64s0-.25,0-.64a3.73,3.73,0,0,1,.1-.68c0-.23.23-.55.42-.42a.84.84,0,0,1,.18.71,1.39,1.39,0,0,1-.23.62A3,3,0,0,1,107.31,441.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.58,430.19s.33.26.76.76a4.58,4.58,0,0,1,.68,4.81,9.55,9.55,0,0,1-.52.94s.09-.06.21-.21a4.17,4.17,0,0,0,.42-.68,4.39,4.39,0,0,0-.7-4.94,4.06,4.06,0,0,0-.59-.53C96.68,430.23,96.59,430.18,96.58,430.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.82,426.84a28.29,28.29,0,0,0-2.14,2.08,26,26,0,0,0-2,2.2A26.24,26.24,0,0,0,99.81,429,27.91,27.91,0,0,0,101.82,426.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.76,437a7.67,7.67,0,0,0,1.39,1.61,7.92,7.92,0,0,0,1.66,1.33s-.7-.64-1.54-1.46S99.8,437,99.76,437Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.7,435.05s-.08.2-.16.42-.18.4-.14.44.21-.12.3-.38S97.74,435.05,97.7,435.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.84,433.35s-.09.17-.08.38,0,.39.09.39.09-.18.08-.39S97.88,433.34,97.84,433.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.14,431.85s.12.17.22.38.14.38.19.39.1-.23,0-.48S97.16,431.81,97.14,431.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.55,430.89s0,.13,0,.25.13.2.18.17,0-.13,0-.24S96.59,430.87,96.55,430.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.12,451.74l-.27-7.73-14.49.41.28,11.32.9,0c4,.11,20.37.27,23-.62C216.51,454.16,204.12,451.74,204.12,451.74Z",
    style: {
      fill: "#FFAD63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.89,455.48a5,5,0,0,0-1.94-3,4.89,4.89,0,0,0-3.42-1l.12,4Z",
    style: {
      fill: "#FFAD63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.18,453.14s4.35,1.12,3.84,1.85-17.07,1.19-24.38.75v-.32L209,455S209.34,453.2,210.18,453.14Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.42,455.41a.72.72,0,0,0,.25,0l.72,0,2.64,0c2.22,0,5.3,0,8.7-.09s6.47-.25,8.69-.39l2.63-.18.72-.06.24,0h-.25l-.71,0-2.64.13c-2.22.11-5.29.24-8.69.33s-6.47.13-8.69.14l-2.64,0h-1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209,455.27a5.26,5.26,0,0,1,.45-1.27,6.1,6.1,0,0,1,.87-1,2,2,0,0,0-1,1A1.92,1.92,0,0,0,209,455.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.62,453.22s.24-.23.44-.57a1.61,1.61,0,0,0,.29-.66s-.24.23-.44.57S204.58,453.19,204.62,453.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.43,452.63s.26-.12.5-.36.41-.44.38-.48-.26.13-.5.36S203.4,452.59,203.43,452.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.65,451.28a1.76,1.76,0,0,0,.76.08,1.7,1.7,0,0,0,.75-.1,1.76,1.76,0,0,0-.76-.08A1.74,1.74,0,0,0,202.65,451.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.37,450.33a2.15,2.15,0,0,0,1.72.08,5.13,5.13,0,0,0-.86,0A4.27,4.27,0,0,0,202.37,450.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.08,451.94a2.79,2.79,0,0,0,.93,0,5.89,5.89,0,0,0,1-.25,2.48,2.48,0,0,0,.56-.25.53.53,0,0,0,.23-.29.37.37,0,0,0-.16-.37,1.69,1.69,0,0,0-2.09.56,1.55,1.55,0,0,0-.29.63.6.6,0,0,0,0,.25,3.15,3.15,0,0,1,.4-.81,1.82,1.82,0,0,1,.79-.54,1.47,1.47,0,0,1,1.11.05c.15.1.1.28-.07.38a3,3,0,0,1-.51.24,7,7,0,0,1-1,.28C205.43,451.9,205.07,451.91,205.08,451.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.32,452a1,1,0,0,0,.09-.65,1.42,1.42,0,0,0-.28-.67.92.92,0,0,0-.78-.46.38.38,0,0,0-.28.44,1,1,0,0,0,.17.41,2.67,2.67,0,0,0,.46.55,1.51,1.51,0,0,0,.54.37s-.19-.17-.46-.45a3.74,3.74,0,0,1-.4-.55c-.13-.2-.23-.55,0-.59s.48.19.63.37a1.79,1.79,0,0,1,.28.6A3.31,3.31,0,0,1,205.32,452Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.61,451.44s.41-.05,1.07,0a4.57,4.57,0,0,1,2.36.9,4.66,4.66,0,0,1,1.52,2,9.86,9.86,0,0,1,.3,1,.81.81,0,0,0,0-.3,5.63,5.63,0,0,0-.18-.77,4.53,4.53,0,0,0-1.53-2.12,4.45,4.45,0,0,0-2.46-.88,3.66,3.66,0,0,0-.8,0A.8.8,0,0,0,189.61,451.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.94,445.37a24,24,0,0,0,0,3,24.31,24.31,0,0,0,.13,3,52.3,52.3,0,0,0-.09-6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.67,454a7.7,7.7,0,0,0,2.12.15,8.91,8.91,0,0,0,2.12-.22c0-.06-.95,0-2.12.05S196.68,454,196.67,454Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.83,454.09s.08.2.19.41.16.41.21.4.07-.23-.06-.47S193.86,454.05,193.83,454.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.72,452.79s.07.18.22.33.31.24.34.2-.06-.18-.22-.33S192.76,452.75,192.72,452.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.17,452.22s.21,0,.42.11.38.18.41.15-.09-.23-.35-.32S191.16,452.18,191.17,452.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.08,452c0,.05.07.12.19.17s.23,0,.25,0-.07-.12-.19-.16S190.09,451.92,190.08,452Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.12,338.3l-5.62,34.46c-1.55,6.79-3.58,15.08-7.31,20.95l-42.77,50.86-19.33-19.8L136.89,370l10.36-56.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.13,328l24.32,53,17.18,67.71,27.7.36L194,375.6l-23.11-74.17-36.09-6.5-.43,3.77a38.52,38.52,0,0,0,5.5,24.83A36.64,36.64,0,0,0,143.13,328Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.48,326.65c-.13.07-.54-.48-.92-1.21s-.59-1.38-.46-1.45.54.47.92,1.21S151.61,326.58,151.48,326.65Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.2,332c-.13.06-.53-.49-.91-1.22s-.57-1.4-.44-1.46.54.48.91,1.22S154.33,331.93,154.2,332Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.85,337.38c-.13.07-.53-.49-.89-1.23s-.56-1.4-.43-1.46.53.49.89,1.23S157,337.32,156.85,337.38Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.42,342.8c-.13.07-.52-.49-.88-1.24s-.53-1.41-.4-1.47.52.5.87,1.25S159.55,342.74,159.42,342.8Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.91,348.26c-.13.06-.51-.5-.86-1.26s-.51-1.41-.38-1.47.52.5.86,1.26S162,348.2,161.91,348.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.33,353.76c-.13.06-.51-.51-.84-1.27s-.49-1.42-.36-1.48.51.51.84,1.27S164.46,353.7,164.33,353.76Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.66,359.28c-.13.06-.5-.52-.82-1.28s-.47-1.43-.33-1.48.49.51.81,1.28S166.8,359.23,166.66,359.28Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.92,364.84c-.13.06-.49-.52-.8-1.29s-.45-1.44-.32-1.49.49.52.8,1.29S169.05,364.79,168.92,364.84Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.1,370.43c-.14.05-.49-.53-.79-1.3s-.43-1.44-.29-1.5.48.54.78,1.31S171.23,370.38,171.1,370.43Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.19,376.06c-.13,0-.48-.55-.76-1.32s-.41-1.45-.28-1.5.48.54.77,1.32S173.33,376,173.19,376.06Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.2,381.71c-.13.05-.47-.55-.74-1.33s-.39-1.45-.25-1.5.47.54.74,1.33S175.34,381.66,175.2,381.71Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.13,387.39c-.13,0-.46-.56-.72-1.34s-.37-1.46-.23-1.51.46.56.72,1.34S177.27,387.34,177.13,387.39Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179,393.1c-.14,0-.45-.56-.71-1.35s-.34-1.47-.2-1.51.45.56.7,1.35S179.11,393.05,179,393.1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.74,398.83c-.14,0-.44-.57-.68-1.36s-.33-1.47-.19-1.51.44.57.68,1.36S180.88,398.79,180.74,398.83Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.42,404.59c-.14,0-.44-.57-.66-1.37s-.31-1.47-.17-1.51.44.57.67,1.37S182.56,404.55,182.42,404.59Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184,410.38c-.14,0-.43-.59-.65-1.38s-.28-1.48-.14-1.52.43.58.64,1.38S184.16,410.34,184,410.38Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.53,416.18c-.14,0-.42-.59-.63-1.39s-.26-1.48-.12-1.51.42.58.63,1.38S185.67,416.15,185.53,416.18Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187,422c-.14,0-.41-.59-.61-1.4s-.24-1.48-.1-1.52.42.59.61,1.4S187.1,422,187,422Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.31,427.85c-.14,0-.41-.59-.59-1.4s-.22-1.49-.08-1.52.41.6.59,1.4S188.45,427.82,188.31,427.85Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.57,433.72c-.14,0-.39-.6-.56-1.41s-.2-1.5-.06-1.53.39.61.57,1.42S189.71,433.69,189.57,433.72Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.76,439.6c-.14,0-.39-.61-.55-1.42s-.18-1.49,0-1.52.38.6.54,1.42S190.9,439.57,190.76,439.6Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.59,444c-.14,0-.32-.28-.39-.69s0-.75.12-.78.32.28.39.69S191.73,444,191.59,444Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "183.21 444.01 184.63 448.68 212.33 449.04 211.2 444.5 183.21 444.01",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.36,444.42a1.59,1.59,0,0,1-.1-.31c-.07-.24-.16-.55-.26-.94-.23-.87-.55-2.08-.95-3.63-.82-3.18-2-7.73-3.44-13.34l-5.18-19.77c-2-7.42-4.19-15.59-6.8-24.06-1.33-4.23-2.81-8.3-4.39-12.17s-3.13-7.6-4.66-11.13c-3.07-7.05-6-13.34-8.42-18.61S150.68,331,149.27,328l-1.61-3.38-.41-.89a1.38,1.38,0,0,1-.12-.3s.07.09.17.28l.46.86,1.69,3.34c1.46,2.91,3.54,7.14,6,12.39s5.43,11.53,8.53,18.58c1.54,3.52,3.14,7.24,4.69,11.13s3.08,8,4.41,12.2c2.62,8.49,4.79,16.67,6.77,24.1s3.67,14.15,5.08,19.8l3.28,13.38c.36,1.56.65,2.78.85,3.65.09.4.15.71.21.95A1.68,1.68,0,0,1,189.36,444.42Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103,421.48c.11.09-.24.68-.78,1.31s-1.06,1.06-1.17,1,.24-.68.78-1.31S102.9,421.38,103,421.48Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.85,416.87c.11.09-.23.68-.75,1.32s-1,1.08-1.16,1,.23-.68.76-1.32S106.74,416.78,106.85,416.87Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.63,412.2c.11.09-.22.69-.74,1.34s-1,1.09-1.14,1,.22-.69.74-1.33S110.52,412.11,110.63,412.2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.37,407.51c.11.09-.21.69-.73,1.34s-1,1.1-1.14,1,.22-.69.73-1.34S114.26,407.42,114.37,407.51Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.1,402.81c.11.09-.22.69-.73,1.34s-1,1.1-1.14,1,.22-.69.73-1.34S118,402.72,118.1,402.81Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.83,398.11c.11.09-.22.69-.73,1.34s-1,1.1-1.14,1,.21-.69.73-1.34S121.71,398,121.83,398.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.59,393.43c.11.1-.22.69-.74,1.33s-1,1.1-1.15,1,.22-.69.74-1.33S125.48,393.34,125.59,393.43Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.4,388.8c.11.1-.23.69-.75,1.32s-1.05,1.08-1.16,1,.22-.68.75-1.32S129.29,388.71,129.4,388.8Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.29,384.24c.11.09-.24.67-.78,1.3s-1.06,1.06-1.17,1,.24-.68.78-1.31S133.18,384.14,133.29,384.24Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.18,379.67c.11.09-.23.68-.77,1.31s-1,1.07-1.16,1,.23-.68.77-1.32S137.07,379.57,137.18,379.67Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141,375c.11.08-.21.68-.73,1.34s-1,1.1-1.13,1,.21-.69.72-1.34S140.84,374.91,141,375Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.49,369.64c.14,0,.07.72-.15,1.52a7.35,7.35,0,0,1-.36,1c-.12.25-.28.4-.33.36s-.05-.19,0-.46a6.58,6.58,0,0,1,.21-1C143.06,370.22,143.35,369.6,143.49,369.64Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.92,363.81c.14,0,.1.71-.09,1.52s-.46,1.44-.6,1.4-.1-.71.09-1.52S144.78,363.78,144.92,363.81Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.13,357.94c.14,0,.12.7,0,1.52s-.4,1.45-.54,1.42-.13-.71,0-1.52S146,357.91,146.13,357.94Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.18,352c.14,0,.14.71,0,1.52s-.37,1.46-.51,1.44-.15-.71,0-1.52S147,352,147.18,352Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.15,346.12c.14,0,.15.7,0,1.52s-.36,1.46-.5,1.43-.15-.7,0-1.52S148,346.09,148.15,346.12Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149,341.12c.14,0,.18.5.09,1.06s-.29,1-.43,1-.18-.5-.09-1.07S148.84,341.09,149,341.12Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.09 424.77 97.93 419.72 116.96 440.36 113.42 444.56 94.09 424.77",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.2,330.28s15.69,55.59,15.89,55,3.41-12.52,3.41-12.52Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.62,255.71l16.84-2.53s7.85,17.12,10,17.69c11.74,3.18,25.2,1.46,29.95.68.55-.43,1.17-.95,1.88-1.6a7.26,7.26,0,0,0,1.5-1.94,11.58,11.58,0,0,0,1.16-2.84,1,1,0,0,1,1.73-.46c.4.76.09,3.34-1.57,5.89s2.89,1.08,4.56.58,6.9-1.81,7.46-1.42c.82.58.36,1.56-1.32,2s-6.61,2.21-6.3,3.08,8.76-1.82,8.76-1.82,1.72-.86,2.1.13c.71,1.79-8.5,4-9.38,4.15-.61.13-.31,1.08.34.91s8.38-2.86,9.11-1c.56,1.39-7.56,1.86-8.85,3.3s6.12-1,6.6.37c.18.51.25.91-4.21,1.68a90.13,90.13,0,0,1-9.75.75v0s-41.43,9.86-51-8.25C163.75,257.17,163.62,255.71,163.62,255.71Z",
    style: {
      fill: "#e5baab"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.47,217.4c1.46-1.14,3.66-.69,5.14.42a22.73,22.73,0,0,1,3.62,4.19c1.16,1.44,2.69,2.79,4.53,2.93a4.76,4.76,0,0,1-7.77,2.21,4.13,4.13,0,0,1,1.33,1.3,1.44,1.44,0,0,1-.2,1.73,1.93,1.93,0,0,1-1.44.27,8.84,8.84,0,0,1-7.75-9.95,5.92,5.92,0,0,1,1.27-3.1,3.61,3.61,0,0,1,3-1.3",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.16,233.37a56.9,56.9,0,0,1,0-6.86s6-.64,6.4-6.62,0-19.79,0-19.79l-11-5.37L148.35,204l.25,29.22-6.06.23,19.21,26.48c2.67-10.28,6.14-19.81,6.28-26Z",
    style: {
      fill: "#e5baab"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.35,210.16a.77.77,0,0,1-.76.77.78.78,0,0,1-.77-.77.77.77,0,0,1,.77-.76A.76.76,0,0,1,169.35,210.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.1,209.33c-.1.1-.67-.39-1.49-.43s-1.45.35-1.53.24.06-.23.33-.41a2,2,0,0,1,1.23-.33,2,2,0,0,1,1.18.47C170.06,209.09,170.14,209.28,170.1,209.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.48,210.16a.77.77,0,1,1-1.53,0,.77.77,0,0,1,1.53,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161,209.33c-.1.1-.67-.39-1.49-.43s-1.45.35-1.53.24.06-.23.33-.41a2,2,0,0,1,1.23-.33,2,2,0,0,1,1.18.47C160.92,209.09,161,209.28,161,209.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.21,217.07a14.9,14.9,0,0,0,4,1.37,2.31,2.31,0,0,1-2.73.78A1.7,1.7,0,0,1,161.21,217.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.16,226.51a15,15,0,0,1-7.93-2.68S158,228.22,164,228Z",
    style: {
      fill: "#d78776"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.3,205.63c3.61-12.39,14.23-14.81,16.4-14.81,2.33,0,6.4-1.28,12.34,4.89a13.68,13.68,0,0,1,2.25,3.1,13.4,13.4,0,0,1,2.64,5.64,6.83,6.83,0,0,1,.14,3c-.11,0-.13-1.13-.6-2.86a14.47,14.47,0,0,0-1.14-2.95,11.39,11.39,0,0,1-.61,6.89l-2.13-.58L161,205.33c.69-2.37-.33-5.3-.9-6.66l-.06,0c-1.75,8.95-11.62,9.88-11.62,9.88l.5,17c-10.13-2.17-10.26-13.23-10.2-16A30,30,0,0,1,139.3,205.63Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.93,216.29a5.74,5.74,0,0,1,1.35-.17c.21,0,.42,0,.46-.19a1.11,1.11,0,0,0-.12-.67c-.18-.54-.36-1.11-.56-1.71-.39-1.21-.73-2.32-1-3.13a4.94,4.94,0,0,1-.3-1.32,5.37,5.37,0,0,1,.52,1.25c.29.79.66,1.88,1.05,3.1l.54,1.72a1.3,1.3,0,0,1,.09.86.52.52,0,0,1-.35.29,1.23,1.23,0,0,1-.36,0A5.26,5.26,0,0,1,163.93,216.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150,211.42c1.86-.36,3.43-.62,4-.66a5.25,5.25,0,0,1-.12-1,4.84,4.84,0,0,1,.95-2.87,4.76,4.76,0,0,1,2.26-1.68,4.86,4.86,0,0,1,2.54-.2,4.77,4.77,0,0,1,2,.93,4.64,4.64,0,0,1,1.69,2.66,3.57,3.57,0,0,1,.11.86,1,1,0,0,1,0,.3s0-.42-.21-1.13a4.67,4.67,0,0,0-1.72-2.51,4.57,4.57,0,0,0-6.41,1,4.55,4.55,0,0,0,2.1,6.94,4.71,4.71,0,0,0,2.39.21,4.61,4.61,0,0,0,1.92-.84,4.68,4.68,0,0,0,1.72-2.5,6,6,0,0,0,.16-.87c-.15,0-.24-.07-.24-.12s.11-.09.28-.12c0,0,0,0,0,0v0a4.35,4.35,0,0,1,.57,0,3,3,0,0,1,.7.07.43.43,0,0,0,0-.05,4.84,4.84,0,0,1,.95-2.87,4.76,4.76,0,0,1,2.26-1.68,4.85,4.85,0,0,1,2.54-.2,4.77,4.77,0,0,1,2,.93,4.64,4.64,0,0,1,1.69,2.66,3.57,3.57,0,0,1,.11.86,1.85,1.85,0,0,1,0,.3s0-.42-.21-1.13a4.67,4.67,0,0,0-1.72-2.51,4.58,4.58,0,0,0-4.31-.62,4.43,4.43,0,0,0-2.1,1.58,4.55,4.55,0,0,0,2.1,6.94,4.71,4.71,0,0,0,2.39.21,4.61,4.61,0,0,0,1.92-.84,4.68,4.68,0,0,0,1.72-2.5c.19-.72.17-1.14.21-1.13a1.71,1.71,0,0,1,0,.3,3.68,3.68,0,0,1-.11.86,4.67,4.67,0,0,1-1.69,2.66,4.76,4.76,0,0,1-4.56.72,4.69,4.69,0,0,1-2.26-1.68,4.89,4.89,0,0,1-.93-2.63,2.51,2.51,0,0,1-.71.08,4.15,4.15,0,0,1-.55,0v0a3.68,3.68,0,0,1-.11.86,4.67,4.67,0,0,1-1.69,2.66,4.76,4.76,0,0,1-4.56.72,4.76,4.76,0,0,1-3.07-3.48c-.51.17-2.06.53-3.93.9a27.89,27.89,0,0,1-4.19.66A28,28,0,0,1,150,211.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.11,219.63c-1.46-1.14-3.67-.69-5.15.42a22.78,22.78,0,0,0-3.62,4.19c-1.16,1.44-2.68,2.78-4.53,2.92a4.77,4.77,0,0,0,7.78,2.21,4.16,4.16,0,0,0-1.33,1.31,1.41,1.41,0,0,0,.19,1.72,1.85,1.85,0,0,0,1.44.27,8.82,8.82,0,0,0,7.76-9.94,5.94,5.94,0,0,0-1.28-3.11,3.56,3.56,0,0,0-3-1.29",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.66,224.24c-.08,0,0-.44-.14-1.11a4.78,4.78,0,0,0-1-2.36,4.65,4.65,0,0,0-2.09-1.45c-.64-.22-1.07-.25-1.07-.33s.44-.17,1.16,0a4.25,4.25,0,0,1,2.41,1.48,4.35,4.35,0,0,1,.95,2.66C144.9,223.83,144.72,224.26,144.66,224.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.34,220.31s.16-.15.53-.12a1.54,1.54,0,0,1,1.18.9,1.92,1.92,0,0,1-.55,2.13,2.87,2.87,0,0,1-2.63.52,6.54,6.54,0,0,1-2.31-1.25,9.31,9.31,0,0,1-1.51-1.5,3.73,3.73,0,0,1-.93-1.7c.07,0,.42.61,1.21,1.46a10.48,10.48,0,0,0,1.52,1.35,6.51,6.51,0,0,0,2.15,1.14,2.46,2.46,0,0,0,2.18-.38,1.56,1.56,0,0,0,.53-1.63,1.4,1.4,0,0,0-.88-.84C178.53,220.31,178.35,220.35,178.34,220.31Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.22,220.55c0,.08-.64.24-1.57.79s-2.06,1.51-3.43,2.51a8.84,8.84,0,0,1-2.14,1.13,5,5,0,0,1-2,.26,2.29,2.29,0,0,1-1.68-.67,8.14,8.14,0,0,0,1.7.3,6.73,6.73,0,0,0,3.8-1.45,25.76,25.76,0,0,1,3.56-2.41A3.3,3.3,0,0,1,139.22,220.55Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.27,207.83c0-.09,1.1.15,2.84.09a13.88,13.88,0,0,0,11.35-6.39c.95-1.46,1.31-2.5,1.4-2.47a2.18,2.18,0,0,1-.19.75,10.86,10.86,0,0,1-.9,1.91,13.23,13.23,0,0,1-11.66,6.57,11,11,0,0,1-2.1-.23C144.53,208,144.27,207.87,144.27,207.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175,272.63l15.28-11L173.16,237.7h0a10.44,10.44,0,0,0-8.59-4.47s2.26,14.42-6.82,14.53-10.35-14.44-10.35-14.44l-.06-.28-1.45.06V233s-.7,0-1.77.13l-2.77.11-.12.26a15.94,15.94,0,0,0-5.94,2c-3.18,2.2-19.79,21.33-19.79,21.33l17.27,12.72,3.71-4.8,1.74,7.05c1.46,5.88-5.61,19.84-5.44,26.33L176.55,303,175,280.85Z",
    style: {
      fill: "#FFAD63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175,272.63l15.28-11L173.16,237.7h0a10.44,10.44,0,0,0-8.59-4.47s2.26,14.42-6.82,14.53-10.35-14.44-10.35-14.44l-.06-.28-1.45.06V233s-.7,0-1.77.13l-2.77.11-.12.26a15.94,15.94,0,0,0-5.94,2c-3.18,2.2-19.79,21.33-19.79,21.33l17.27,12.72,3.71-4.8,1.74,7.05c1.46,5.88-5.61,19.84-5.44,26.33L176.55,303,175,280.85Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.63,251.9s-.26,0-.74,0a4.28,4.28,0,0,0-2,.66,9.09,9.09,0,0,0-2.42,2.32,12.89,12.89,0,0,1-3.23,3.19,11,11,0,0,1-5.24,1.73,10.69,10.69,0,0,1-6.16-1.42c-1.95-1.15-3.53-3-5.69-3.87s-4.75-.37-7,.78-4.18,2.75-6.36,3.87a11.41,11.41,0,0,1-3.4,1.2,9.86,9.86,0,0,1-3.47,0,10.21,10.21,0,0,1-5.59-2.94c-1.4-1.4-2.54-2.85-4-3.64a8,8,0,0,0-4.25-1,8.72,8.72,0,0,0-3.24.82,8.39,8.39,0,0,0-1.78,1.16,5.09,5.09,0,0,1-.56.5,4.15,4.15,0,0,1,.49-.58,7.79,7.79,0,0,1,1.76-1.27,8.86,8.86,0,0,1,3.31-.92,8.21,8.21,0,0,1,4.45.94c1.54.82,2.73,2.3,4.11,3.65a9.84,9.84,0,0,0,5.37,2.78,10.11,10.11,0,0,0,6.56-1.17c2.11-1.09,4-2.71,6.36-3.89a11.82,11.82,0,0,1,3.65-1.22,6.87,6.87,0,0,1,3.73.44c2.31,1,3.88,2.83,5.74,3.93a10.31,10.31,0,0,0,5.89,1.4,10.74,10.74,0,0,0,5.07-1.61,12.62,12.62,0,0,0,3.21-3.07,9.15,9.15,0,0,1,2.53-2.31,4.22,4.22,0,0,1,2.1-.58A2.15,2.15,0,0,1,182.63,251.9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.83,241.57a11.63,11.63,0,0,0-1.94.57,10.93,10.93,0,0,0-2.07,1.16,24.73,24.73,0,0,0-2.45,2,32.26,32.26,0,0,1-3,2.46,15,15,0,0,1-4,2,15.56,15.56,0,0,1-10.1-.21c-3.44-1.27-6.24-3.33-8.92-4.87a28.2,28.2,0,0,0-3.91-2,17,17,0,0,0-3.64-1.07,12.11,12.11,0,0,0-5.46.25c-1.25.37-1.87.76-1.9.71a1.86,1.86,0,0,1,.45-.29,8.5,8.5,0,0,1,1.39-.62,11.9,11.9,0,0,1,5.58-.42,17.6,17.6,0,0,1,3.74,1,28.21,28.21,0,0,1,4,2c2.72,1.54,5.52,3.57,8.86,4.8a14.9,14.9,0,0,0,5,.93,15.2,15.2,0,0,0,4.73-.69,14.82,14.82,0,0,0,3.92-1.87,34,34,0,0,0,3-2.38,23.92,23.92,0,0,1,2.53-2,11,11,0,0,1,2.15-1.1,7.89,7.89,0,0,1,1.49-.37A1.36,1.36,0,0,1,175.83,241.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.26,237.36a9.84,9.84,0,0,1-1.78-.62,20.15,20.15,0,0,0-4.37-1,19.33,19.33,0,0,0-4.49,0,10.83,10.83,0,0,1-1.87.22,4.93,4.93,0,0,1,1.81-.59,15.42,15.42,0,0,1,9.06,1,9.67,9.67,0,0,1,1.24.64C148.14,237.22,148.28,237.33,148.26,237.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.54,236c.05.05-.22.39-.77.83a8.09,8.09,0,0,1-2.42,1.26,7.88,7.88,0,0,1-2.7.37c-.7,0-1.12-.16-1.11-.22a28.68,28.68,0,0,0,3.65-.65A28.78,28.78,0,0,0,171.54,236Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.47,264.21a1.44,1.44,0,0,1-.36.37,5.2,5.2,0,0,1-1.26.8,9.82,9.82,0,0,1-5.39.59c-1.14-.14-2.37-.41-3.69-.65a20.26,20.26,0,0,0-4.22-.38,36.33,36.33,0,0,0-9.57,1.8,88.42,88.42,0,0,1-9.5,2.61,21.21,21.21,0,0,1-8.07.13,13.46,13.46,0,0,1-5-2,9.49,9.49,0,0,1-1.17-.91c-.25-.23-.37-.36-.36-.38a2.22,2.22,0,0,1,.43.3,12.61,12.61,0,0,0,1.21.82,14.25,14.25,0,0,0,5,1.8,21.43,21.43,0,0,0,7.91-.24,97.47,97.47,0,0,0,9.44-2.64,35.76,35.76,0,0,1,9.71-1.78,20.23,20.23,0,0,1,4.31.44c1.33.26,2.54.54,3.66.71a9.92,9.92,0,0,0,5.26-.42A9.48,9.48,0,0,0,186.47,264.21Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.48,253.22a21.38,21.38,0,0,1-2,2.44c-1.27,1.47-3,3.51-4.89,5.81s-3.54,4.41-4.74,5.94a19.58,19.58,0,0,1-2,2.42,17.25,17.25,0,0,1,1.72-2.64c1.13-1.59,2.75-3.74,4.63-6.05s3.67-4.32,5-5.73A16.1,16.1,0,0,1,146.48,253.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.33,272.24c-.07-.06.87-1.12,2.13-3a11.94,11.94,0,0,0,1.68-3.51,6.71,6.71,0,0,0,.22-2.25,7.53,7.53,0,0,0-.6-2.36,21.12,21.12,0,0,0-2.56-4.08,26.54,26.54,0,0,1-2.21-3.34,8.77,8.77,0,0,1-.89-2.58,3.56,3.56,0,0,1,0-1,3.63,3.63,0,0,1,.23,1,10.29,10.29,0,0,0,1,2.44,31,31,0,0,0,2.28,3.24,20.21,20.21,0,0,1,2.65,4.16,7.85,7.85,0,0,1,.63,2.52,7.29,7.29,0,0,1-.27,2.41,11.54,11.54,0,0,1-1.84,3.6,22.59,22.59,0,0,1-1.71,2.09A4,4,0,0,1,172.33,272.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165,233.48s0,.53-.1,1.48,0,2.34-.09,4.06a13.16,13.16,0,0,1-1.3,5.94,6.39,6.39,0,0,1-2.54,2.62,7,7,0,0,1-3.85.75,7.91,7.91,0,0,1-3.69-1.28,10,10,0,0,1-2.63-2.51,15.08,15.08,0,0,1-2.47-5.54,33.12,33.12,0,0,1-.67-4,9.19,9.19,0,0,1-.09-1.49,7.38,7.38,0,0,1,.29,1.46c.17.95.38,2.32.82,4a15.49,15.49,0,0,0,2.5,5.36,8.5,8.5,0,0,0,6,3.55,6.53,6.53,0,0,0,3.57-.68,6,6,0,0,0,2.36-2.4,13.31,13.31,0,0,0,1.35-5.72c.09-1.71.13-3.11.26-4.06.06-.48.13-.85.18-1.1S165,233.47,165,233.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.62,319.94l1.95-41.07a6,6,0,0,0-5.71-6.28L83.67,266.92a6,6,0,0,0-6.28,5.71l-2,41.06A6,6,0,0,0,81.15,320L184,324.87l10.63,11.4.81-10.85,4.91.23A6,6,0,0,0,206.62,319.94Z",
    style: {
      fill: "#FFAD63"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.92,
    y: 287.69,
    width: 63.21,
    height: 3.48,
    transform: "matrix(1, 0.05, -0.05, 1, 13.95, -7.4)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.49,
    y: 296.64,
    width: 63.21,
    height: 3.48,
    transform: "translate(14.37 -7.37) rotate(2.73)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.1,
    y: 304.58,
    width: 31.33,
    height: 3.48,
    transform: "translate(14.73 -6.58) rotate(2.73)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.1,
    cy: 294.39,
    r: 20.82,
    transform: "translate(-67.91 33.27) rotate(-13.94)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.49,289.64a.87.87,0,0,1-.11.09,6,6,0,0,1-2.62.62c-5.58.55-9.3-2.85-12.14-3.28s-2.75,2.9-2.75,2.9l-.22,7.86-1.39,0-.66-4.68a3.83,3.83,0,0,0-1.15,0c-1.14.15-2.68.89-2.58,3.79.1,3.31,2.56,3.3,3.85,3l-.48,12.81a20.66,20.66,0,0,0,8.87,2.49,20.89,20.89,0,0,0,4-.2c.13-1.22.26-2.62.36-3.61-5.29-.1-6.49-4.05-6.49-4.05a12.23,12.23,0,0,0,6.62,2.69v.08c.1,0,5.33-.3,6-5.48C112,300.84,112.34,293.46,112.49,289.64Zm-20.55,8.67a.85.85,0,0,1-.71.14,2,2,0,0,1-1.21-1.9,2.7,2.7,0,0,1,.23-1.26,1.12,1.12,0,0,1,.8-.73.62.62,0,0,1,.43.1.52.52,0,0,1,.19.28c0,.18,0,.27,0,.26s0-.09-.06-.22a.41.41,0,0,0-.47-.2.89.89,0,0,0-.57.62,2.45,2.45,0,0,0-.18,1.13,1.92,1.92,0,0,0,1,1.71.79.79,0,0,0,.58,0c.13-.07.19-.14.21-.13S92.07,298.19,91.94,298.31Zm9.29-3.8s.07-.2.31-.35a1.78,1.78,0,0,1,2.11.26c.21.2.27.38.22.41s-.56-.37-1.28-.45S101.3,294.61,101.23,294.51Zm2.3,1.34a.77.77,0,1,1-1.21-.94.79.79,0,0,1,1.08-.14A.78.78,0,0,1,103.53,295.85Zm5.93-1.46a1.8,1.8,0,0,1,2.11.25c.21.21.27.38.22.42s-.56-.37-1.28-.46-1.29.24-1.36.14S109.21,294.53,109.46,294.39Zm-1.86,4.29c.13.53.25,1,.38,1.53a1.28,1.28,0,0,1,0,.8.51.51,0,0,1-.36.27,1.14,1.14,0,0,1-.32,0,3.36,3.36,0,0,1-1.19-.17,3.38,3.38,0,0,1,1.19-.12c.2,0,.35,0,.37-.12a1,1,0,0,0-.07-.56c-.14-.5-.27-1-.41-1.53a20.61,20.61,0,0,1-.82-4A20.43,20.43,0,0,1,107.6,298.68Zm-2.93,4.93c-1.51-.75-1-2-1-2-.7-.53,2,1.33,3.43,1.42A2,2,0,0,1,104.67,303.61Zm6.8-7.43a.77.77,0,0,1-1.08-.06.78.78,0,0,1,.06-1.09.77.77,0,0,1,1.09.07A.76.76,0,0,1,111.47,296.18Z",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.54,295.1a.77.77,0,0,0-1.09-.07.78.78,0,0,0-.06,1.09.77.77,0,0,0,1.08.06A.76.76,0,0,0,111.54,295.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.51,294.6c.72.09,1.19.54,1.28.46s0-.21-.22-.42a1.8,1.8,0,0,0-2.11-.25c-.25.14-.35.3-.31.35S109.79,294.51,110.51,294.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.4,294.77a.79.79,0,0,0-1.08.14.77.77,0,1,0,1.08-.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.87,294.83s0-.21-.22-.41a1.78,1.78,0,0,0-2.11-.26c-.24.15-.34.31-.31.35s.64-.22,1.36-.13S103.78,294.92,103.87,294.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.61,300.31a1,1,0,0,1,.07.56c0,.1-.17.12-.37.12a3.38,3.38,0,0,0-1.19.12,3.36,3.36,0,0,0,1.19.17,1.14,1.14,0,0,0,.32,0A.51.51,0,0,0,108,301a1.28,1.28,0,0,0,0-.8c-.13-.5-.25-1-.38-1.53a20.43,20.43,0,0,0-1.22-3.9,20.61,20.61,0,0,0,.82,4C107.34,299.31,107.47,299.81,107.61,300.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.68,301.65s-.52,1.21,1,2a2,2,0,0,0,2.44-.54C105.64,303,103,301.12,103.68,301.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99,307.33s1.2,3.95,6.49,4.05h0l.13-1.28V310A12.23,12.23,0,0,1,99,307.33Z",
    style: {
      fill: "#a36957"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.26,297.79l1.39,0,.22-7.86s-.08-3.32,2.75-2.9,6.56,3.83,12.14,3.28a6,6,0,0,0,2.62-.62.87.87,0,0,0,.11-.09,2.49,2.49,0,0,0,1.19-2.15,1.74,1.74,0,0,0-1.81-1.63,2,2,0,1,0-.92-3.71,5.91,5.91,0,0,0,1.6-1.82,2,2,0,0,0-.26-2.27,2.22,2.22,0,0,0-2.27-.25c-1.14.43-2.07,1.33-3.24,1.67a12.51,12.51,0,0,1-3.67.08,6.54,6.54,0,0,0-3.85,1.13,4.37,4.37,0,0,0-1.86,3.46c-1.71-.29-3.61-.41-5,.6a5,5,0,0,0-1.84,3.81,14.89,14.89,0,0,0,.83,4.29h0a1.47,1.47,0,0,0,.08.25,3.83,3.83,0,0,1,1.15,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.87,298.21a.79.79,0,0,1-.58,0,1.92,1.92,0,0,1-1-1.71,2.45,2.45,0,0,1,.18-1.13.89.89,0,0,1,.57-.62.41.41,0,0,1,.47.2c.06.13,0,.22.06.22s.09-.08,0-.26a.52.52,0,0,0-.19-.28.62.62,0,0,0-.43-.1,1.12,1.12,0,0,0-.8.73,2.7,2.7,0,0,0-.23,1.26,2,2,0,0,0,1.21,1.9.85.85,0,0,0,.71-.14c.13-.12.15-.22.14-.23S92,298.14,91.87,298.21Z",
    style: {
      fill: "#a36957"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.9,315.8c-2-1.21-4.44-2.93-4.65-4v0l-.3-1.76c-1-6.92-1.81-23.06-.64-32.54.13-1,3.47-4.82,7.23-8.84L119,259.33l-2,2.5c-10.63,13.33-6.87,39.88-4.8,50.52h0l1.13,5.8s.94,6.37,1.78,6.76,1.3-.56,1.3-.56.89,1.11,1.62,1c.92-.11,1.36-1.8,1.36-1.8s.85,1.37,1.64,1.36c1,0,1.23-1.64,1.23-1.64a2.67,2.67,0,0,0,2.29,1.34,1.57,1.57,0,0,0,1.34-1.17s-1.37-6-.57-6.59,2,.48,2.55.68,3.57,1.52,5.12.66S131.88,317,129.9,315.8Z",
    style: {
      fill: "#e5baab"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileimage);
export default __webpack_public_path__ + "static/media/profileimage.7533cf011c83bdc3f9e3f7acfdbc9518.svg";
export { ForwardRef as ReactComponent };